var AnimatesDurationAtur = 300;


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  LISTING MITRA !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

// ====================================== PREPARE THE LANGUAGE UI ====================================

window.PrepareListingMitraPageElements = function()
{
    let PropertyAuditButton = document.getElementById("PropertyAuditButton");
    if(PropertyAuditButton != null)
    {
        PropertyAuditButton.onclick = function()
        {
            window.InstantiateJoinMitra();
        }
    }

    document.getElementById("PropertyAuditText").innerHTML = window["GabungSekarangTxt" + window.CurrentCountryID];
    document.getElementById("PropertyAuditMobileText").innerHTML = window["GabungTxt" + window.CurrentCountryID];

    document.getElementById("ListtYourHeader1Text").innerHTML = window["Section1HeaderListTxt" + window.CurrentCountryID];
    document.getElementById("AccommodationHeader1Text").innerHTML = window["Section1HeaderAccommodationTxt" + window.CurrentCountryID];
    document.getElementById("OnPingingoHeader1Text").innerHTML = window["Section1HeaderOnPinginGoTxt" + window.CurrentCountryID];
    document.getElementById("Section1MessageText").innerHTML = window["TopMessageListingMitraTxt" + window.CurrentCountryID];
    document.getElementById("JoinNowButtonText1").innerHTML = window["GabungSekarangTxt" + window.CurrentCountryID];

    document.getElementById("TentangHeader2Text").innerHTML = window["TentangTxt" + window.CurrentCountryID];
    document.getElementById("Section2Message1Text").innerHTML = window["Message1Section2Txt" + window.CurrentCountryID];
    document.getElementById("Section2Message2Text").innerHTML = window["Message2Section2Txt" + window.CurrentCountryID];

    document.getElementById("MemilihHeader3Text").innerHTML = window["ChooseTxt" + window.CurrentCountryID];
    document.getElementById("MenjadiPartnerAndaHeader3Text").innerHTML = window["BecomeYourPartnerTxt" + window.CurrentCountryID];
    document.getElementById("Benefit1Header3Text").innerHTML = window["ReasonHeader1Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit1Message3Text").innerHTML = window["ReasonMessage1Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit2Header3Text").innerHTML = window["ReasonHeader2Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit2Message3Text").innerHTML = window["ReasonMessage2Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit3Header3Text").innerHTML = window["ReasonHeader3Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit3Message3Text").innerHTML = window["ReasonMessage3Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit4Header3Text").innerHTML = window["ReasonHeader4Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit4Message3Text").innerHTML = window["ReasonMessage4Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit5Header3Text").innerHTML = window["ReasonHeader5Section3Txt" + window.CurrentCountryID];
    document.getElementById("Benefit5Message3Text").innerHTML = window["ReasonMessage5Section3Txt" + window.CurrentCountryID];

    document.getElementById("HeaderSection4Text").innerHTML = window["Section4HeaderTxt" + window.CurrentCountryID];
    document.getElementById("MessageSection4Text").innerHTML = window["Section4MessageTxt" + window.CurrentCountryID];
    let AccommodationTypeWrapper = document.getElementById("AccommodationTypeSwiperWrapper");
    AccommodationTypeWrapper.innerHTML = "";

    for(let i = 0; i < window.AccommodationTypeListingTxt.length; i++)
    {
        let AccomodationTypeSwiper = document.createElement("div");
        AccomodationTypeSwiper.className = "swiper-slide AccomodationTypeSwiper RowGapBasic2";
        AccommodationTypeWrapper.append(AccomodationTypeSwiper);

        let AccomodationTypeImage = document.createElement("img");
        AccomodationTypeImage.className = "AccomodationTypeImage";
        AccomodationTypeImage.src = process.env.PUBLIC_URL + window.AccommodationTypeListingTxt[i].image_url_big;
        AccomodationTypeSwiper.append(AccomodationTypeImage);

        let AccommodationTypeNameText = document.createElement("p");
        AccommodationTypeNameText.className = "InterBoldTextFont MidSizeText";
        AccommodationTypeNameText.innerHTML = window.AccommodationTypeListingTxt[i].type_name[window.CurrentCountryID];
        AccomodationTypeSwiper.append(AccommodationTypeNameText);

        let AccommodationTypeDescText = document.createElement("p");
        AccommodationTypeDescText.className = "InterRegularTextFont MidSizeText2";
        AccommodationTypeDescText.innerHTML = window.AccommodationTypeListingTxt[i].description[window.CurrentCountryID];
        AccomodationTypeSwiper.append(AccommodationTypeDescText);
    }

    document.getElementById("Section5HeaderText").innerHTML = window["Section5HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section5MessageText").innerHTML = window["Section5MessageTxt" + window.CurrentCountryID];

    document.getElementById("Section6HeaderText").innerHTML = window["Section6HeaderTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramHeader1").innerHTML = window["OurProgram1HeaderTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramMessage1").innerHTML = window["OurProgram1MessageTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramHeader2").innerHTML = window["OurProgram2HeaderTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramMessage2").innerHTML = window["OurProgram2MessageTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramMessage3").innerHTML = window["OurProgram3MessageTxt" + window.CurrentCountryID];
    document.getElementById("OurProgramMessage4").innerHTML = window["OurProgram4MessageTxt" + window.CurrentCountryID];

    document.getElementById("HeaderSection7Text").innerHTML = window["Section7HeaderTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepHeader1").innerHTML = window["Section7Hint1HeaderTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepMessage1").innerHTML = window["Section7Hint1MessageTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepHeader2").innerHTML = window["Section7Hint2HeaderTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepMessage2").innerHTML = window["Section7Hint2MessageTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepHeader3").innerHTML = window["Section7Hint3HeaderTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepMessage3").innerHTML = window["Section7Hint3MessageTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepHeader4").innerHTML = window["Section7Hint4HeaderTxt" + window.CurrentCountryID];
    document.getElementById("DaftarStepMessage4").innerHTML = window["Section7Hint4MessageTxt" + window.CurrentCountryID];

    document.getElementById("Section8HeaderText").innerHTML = window["Section8HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader1").innerHTML = window["Section8Hint1HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage1").innerHTML = window["Section8Hint1MessageTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader2").innerHTML = window["Section8Hint2HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage2").innerHTML = window["Section8Hint2MessageTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader3").innerHTML = window["Section8Hint3HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage3").innerHTML = window["Section8Hint3MessageTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader4").innerHTML = window["Section8Hint4HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage4").innerHTML = window["Section8Hint4MessageTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader5").innerHTML = window["Section8Hint5HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage5").innerHTML = window["Section8Hint5MessageTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoHeader6").innerHTML = window["Section8Hint6HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AturAccommodationInfoMessage6").innerHTML = window["Section8Hint6MessageTxt" + window.CurrentCountryID];

    document.getElementById("BergabunglahMessageText").innerHTML = window["Section85MessageTxt" + window.CurrentCountryID];
    document.getElementById("BergabunglahSectionButton").innerHTML = window["Section85DaftarkanButtonTxt" + window.CurrentCountryID];
    document.getElementById("BergabunglahSectionButtonMobile").innerHTML = window["Section85DaftarkanButtonShortTxt" + window.CurrentCountryID];

    document.getElementById("Section9HeaderText").innerHTML = window["Section9HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section9MessageText").innerHTML = window["Section9MessageTxt" + window.CurrentCountryID];
    document.getElementById("SocialInstagramText").innerHTML = window["InstagramTxt" + window.CurrentCountryID];
    document.getElementById("SocialFacebookText").innerHTML = window["FacebookTxt" + window.CurrentCountryID];
    document.getElementById("SocialCrowdSharingText").innerHTML = window["CrowdSharingTxt" + window.CurrentCountryID];
    document.getElementById("SocialWhatsApptext").innerHTML = window["WhatsAppTxt" + window.CurrentCountryID];
    document.getElementById("SocialPopUpBannerText").innerHTML = window["PopUpBannerTxt" + window.CurrentCountryID];
    document.getElementById("SocialTiktokText").innerHTML = window["TikTokTxt" + window.CurrentCountryID];
    document.getElementById("SocialEmailBlastText").innerHTML = window["EmailBlastTxt" + window.CurrentCountryID];
    document.getElementById("SocialPingingoBlogText").innerHTML = window["BlogPinginGoTxt" + window.CurrentCountryID];

    document.getElementById("InstagramSectionHeaderText").innerHTML = window["InstagramTxt" + window.CurrentCountryID];
    document.getElementById("InstagramSectionMessageText").innerHTML = window["Section10InstagramBenefits1Txt" + window.CurrentCountryID];
    document.getElementById("InstagramSectionListText1").innerHTML = window["Section10InstagramBenefits2Txt" + window.CurrentCountryID];
    document.getElementById("InstagramSectionListText2").innerHTML = window["Section10InstagramBenefits3Txt" + window.CurrentCountryID];
    document.getElementById("InstagramSectionListText3").innerHTML = window["Section10InstagramBenefits4Txt" + window.CurrentCountryID];
    document.getElementById("InstagramSectionListFooterText").innerHTML = window["Section10InstagramBenefits5Txt" + window.CurrentCountryID];
    
    document.getElementById("FacebookSectionHeaderText").innerHTML = window["FacebookTxt" + window.CurrentCountryID];
    document.getElementById("FacebookSectionMessageText").innerHTML = window["Section10FacebookBenefits1Txt" + window.CurrentCountryID];
    document.getElementById("FacebookSectionListText1").innerHTML = window["Section10FacebookBenefits2Txt" + window.CurrentCountryID];
    document.getElementById("FacebookSectionListText2").innerHTML = window["Section10FacebookBenefits3Txt" + window.CurrentCountryID];
    document.getElementById("FacebookSectionListText3").innerHTML = window["Section10FacebookBenefits4Txt" + window.CurrentCountryID];
    document.getElementById("FacebookSectionListFooterText").innerHTML = window["Section10FacebookBenefits5Txt" + window.CurrentCountryID];
    
    document.getElementById("TiktokSectionHeaderText").innerHTML = window["TikTokTxt" + window.CurrentCountryID];
    document.getElementById("TiktokSectionMessageText").innerHTML = window["Section10TiktokBenefits1Txt" + window.CurrentCountryID];
    document.getElementById("TiktokSectionListText1").innerHTML = window["Section10TiktokBenefits2Txt" + window.CurrentCountryID];
    document.getElementById("TiktokSectionListText2").innerHTML = window["Section10TiktokBenefits3Txt" + window.CurrentCountryID];
    document.getElementById("TiktokSectionListText3").innerHTML = window["Section10TiktokBenefits4Txt" + window.CurrentCountryID];
    document.getElementById("TiktokSectionListFooterText").innerHTML = window["Section10TiktokBenefits5Txt" + window.CurrentCountryID];
    
    document.getElementById("BlogSectionHeaderText").innerHTML = window["BlogPinginGoTxt" + window.CurrentCountryID];
    document.getElementById("BlogSectionMessageText").innerHTML = window["Section10BlogPinginGoBenefits1Txt" + window.CurrentCountryID];
    document.getElementById("BlogSectionListText1").innerHTML = window["Section10BlogPinginGoBenefits2Txt" + window.CurrentCountryID];
    document.getElementById("BlogSectionListText2").innerHTML = window["Section10BlogPinginGoBenefits3Txt" + window.CurrentCountryID];
    document.getElementById("BlogSectionListText3").innerHTML = window["Section10BlogPinginGoBenefits4Txt" + window.CurrentCountryID];
    document.getElementById("BlogSectionListText4").innerHTML = window["Section10BlogPinginGoBenefits5Txt" + window.CurrentCountryID];

    document.getElementById("PingNShareSectionHeaderText").innerHTML = window["CrowdSharing2Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionMessageText").innerHTML = window["Section10CrowdSharingBenefits1Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionListText1").innerHTML = window["Section10CrowdSharingBenefits2Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionListText2").innerHTML = window["Section10CrowdSharingBenefits3Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionListText3").innerHTML = window["Section10CrowdSharingBenefits4Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionListText4").innerHTML = window["Section10CrowdSharingBenefits5Txt" + window.CurrentCountryID];
    document.getElementById("PingNShareSectionListFooterText").innerHTML = window["Section10CrowdSharingBenefits6Txt" + window.CurrentCountryID];

    document.getElementById("Section11HeaderText").innerHTML = window["Section11Messsage1Txt" + window.CurrentCountryID];
    document.getElementById("Seection11Message1Text").innerHTML = window["Section11Messsage2Txt" + window.CurrentCountryID];
    document.getElementById("Seection11Message2Text").innerHTML = window["Section11Messsage3Txt" + window.CurrentCountryID];
    document.getElementById("Section11DafterBtnTextMobile").innerHTML = window["Section85DaftarkanButtonShortTxt" + window.CurrentCountryID];
    document.getElementById("Section11DafterBtnText").innerHTML = window["Section85DaftarkanButtonTxt" + window.CurrentCountryID];

    document.getElementById("AturAkomodasiCheck1").checked = true;

    let ourProgramSwipper = new window.Swiper(".SwiperExtraPagecontainer", {
        modules: [window.Navigation, window.Pagination],

        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: false,
        observer: true,
        observeParents: true,

        navigation: {
            prevEl: document.getElementById("OurProgramPrevButton"),
            nextEl: document.getElementById("OurProgramNextButton"),
        },

        pagination: {
            el: ".OrangeSwiperPagination",
            clickable: true,
        },
    });

    let SwipperAccommodation = new window.Swiper(".SwiperAccomodationTypeContainer", {
        modules: [window.Navigation, window.Pagination],

        slidesPerView: 'auto',
        freeMode: false,
        observer: true,
        observeParents: true,

        navigation: {
            prevEl: document.getElementById("AccommodationPrevButton"),
            nextEl: document.getElementById("AccommodationNextButton"),
        }
    });

    window.scrollTrigger('.PlayableOnScroll',
    {
        rootMargin: '-200px',
    })
}

// ====================================== INSTANTIATE MITRA ==========================================

window.UploadedListingMitraImage = []

window.InstantiateJoinMitra = function()
{
    window.UploadedListingMitraImage = []

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.id = "PopUpPanelBlockerBermitra";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel HideScrollBar BasicRadius";
    FlexFullDisplayPanel.style.maxHeight = "none";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let FlexContainerBaseAnimate = document.createElement("div");
    FlexContainerBaseAnimate.className = "FlexContainerBaseAnimate RowGapBasic";
    FlexFullDisplayPanel.append(FlexContainerBaseAnimate);

    // HEADER =======================================================================

    let HeaderContainerWrapper = document.createElement("div");
    HeaderContainerWrapper.style.width = "100%";
    HeaderContainerWrapper.style.height = "fit-content";
    HeaderContainerWrapper.style.margin ="0 auto";
    HeaderContainerWrapper.style.flexDirection ="column";
    HeaderContainerWrapper.style.display = "flex";
    FlexContainerBaseAnimate.append(HeaderContainerWrapper);

    let CancelButtonTop = document.createElement("img");
    CancelButtonTop.className = "CloseButtonInsidePanel Selectable2";
    CancelButtonTop.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CancelButtonTop.style.marginLeft ="auto";
    CancelButtonTop.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    HeaderContainerWrapper.append(CancelButtonTop);

    let HeaderMainText = document.createElement("p");
    HeaderMainText.className = "MidSizeText InterSuperBoldTextFont";
    HeaderMainText.innerHTML = window["HelloMitraPinginGoTxt" + window.CurrentCountryID];
    HeaderMainText.style.margin ="0 auto";
    HeaderContainerWrapper.append(HeaderMainText);

    let HeaderMainMessageText = document.createElement("p");
    HeaderMainMessageText.className = "MidSizeText3 InterRegularTextFont";
    HeaderMainMessageText.innerHTML = window["BermitraTopMessageTxt1" + window.CurrentCountryID];
    HeaderMainMessageText.style.margin ="0 auto";
    HeaderContainerWrapper.append(HeaderMainMessageText);


    // SECTION 1 (CHOOSE YOUR ACCOMMODATION) =======================================================================

    let ChooseYourAcccommodatioMainContainer = document.createElement("div");
    ChooseYourAcccommodatioMainContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic HideScrollBar";
    ChooseYourAcccommodatioMainContainer.style.display = "";
    FlexContainerBaseAnimate.append(ChooseYourAcccommodatioMainContainer);

    let ChooseYourAcccommodationScrollContainer = document.createElement("div");
    ChooseYourAcccommodationScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer MaskOnlyButton HideScrollBar ThinPaddingWrapper";
    ChooseYourAcccommodatioMainContainer.append(ChooseYourAcccommodationScrollContainer);

    /* Basic Accommodation Choice ----------------------------------------------- */

    for(let i = 0; i < window.AccommodationTypeListingTxt.length; i++)
    {
        let AccommodationTypeChoiceLabel = document.createElement("label");
        AccommodationTypeChoiceLabel.className = "AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable";
        ChooseYourAcccommodationScrollContainer.append(AccommodationTypeChoiceLabel);

        let AccommodationTypeChoiceInputRadio = document.createElement("input");
        AccommodationTypeChoiceInputRadio.type = "radio";
        AccommodationTypeChoiceInputRadio.name = "TypeOfAccomodationBermitra";
        AccommodationTypeChoiceInputRadio.className = "TypeBermitraCheckBox";
        AccommodationTypeChoiceInputRadio.value = window.AccommodationTypeListingTxt[i].type_selected;
        AccommodationTypeChoiceInputRadio.onchange = function()
        {
            CheckFunctionToCall(1, true);
        }
        AccommodationTypeChoiceLabel.append(AccommodationTypeChoiceInputRadio);

        let AccommodationTypeChoiceImage = document.createElement("img");
        AccommodationTypeChoiceImage.src = process.env.PUBLIC_URL + window.AccommodationTypeListingTxt[i].image_url;
        AccommodationTypeChoiceImage.className = "FormSelectionHotelImage BasicRadius";
        AccommodationTypeChoiceLabel.append(AccommodationTypeChoiceImage);
        
        let AccommodationTypeChoiceWrapper = document.createElement("div");
        AccommodationTypeChoiceWrapper.className = "FormTypeDescriptionWrapper";
        AccommodationTypeChoiceLabel.append(AccommodationTypeChoiceWrapper);

        let AccommodationTypeNameText = document.createElement("p");
        AccommodationTypeNameText.className = "InterBoldTextFont MidSizeText";
        AccommodationTypeNameText.innerHTML = window.AccommodationTypeListingTxt[i].type_name[window.CurrentCountryID];
        AccommodationTypeChoiceWrapper.append(AccommodationTypeNameText);

        let AccommodationTypeDescriptionText = document.createElement("p");
        AccommodationTypeDescriptionText.className = "InterRegularTextFont MidSizeText2";
        AccommodationTypeDescriptionText.style.color = "rgb(102, 112, 133)";
        AccommodationTypeDescriptionText.style.margin = "0px";
        AccommodationTypeDescriptionText.innerHTML = window.AccommodationTypeListingTxt[i].description[window.CurrentCountryID];
        AccommodationTypeChoiceWrapper.append(AccommodationTypeDescriptionText);
    }

    /* Others ----------------------------------------------- */

    let OthersChoiceLabel = document.createElement("label");
    OthersChoiceLabel.className = "AccomodationTypeListingChoiceContainer BasicMarginBottom BasicPaddingWrapper BasicRadius BasicThinGreyBorder ColumnGapBasic2 Selectable OtherTypeAccListing";
    ChooseYourAcccommodationScrollContainer.append(OthersChoiceLabel);

    let OthersChoiceInputRadio = document.createElement("input");
    OthersChoiceInputRadio.type = "radio";
    OthersChoiceInputRadio.name = "TypeOfAccomodationBermitra";
    OthersChoiceInputRadio.className = "TypeBermitraCheckBox";
    OthersChoiceInputRadio.value = "Others";
    OthersChoiceLabel.append(OthersChoiceInputRadio);

    let OthersChoiceImage = document.createElement("img");
    OthersChoiceImage.src = process.env.PUBLIC_URL + "/Assets/images/ExtraPage/MitraTypeChoiceImage/Others.svg";
    OthersChoiceImage.className = "FormSelectionHotelImage BasicRadius";
    OthersChoiceLabel.append(OthersChoiceImage);

    let OthersChoiceWrapper = document.createElement("div");
    OthersChoiceWrapper.className = "FormTypeDescriptionWrapper RowGapBasic4";
    OthersChoiceLabel.append(OthersChoiceWrapper);

    let OthersNameText = document.createElement("p");
    OthersNameText.className = "InterBoldTextFont MidSizeText";
    OthersNameText.innerHTML = window["OthersTypeChoiceTxt" + window.CurrentCountryID];
    OthersChoiceWrapper.append(OthersNameText);

    let OthersInputWrap = document.createElement("div");
    OthersInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    OthersInputWrap.style.width = "100%";
    OthersInputWrap.style.minWidth = "100%";
    OthersInputWrap.style.display = "flex";
    OthersChoiceWrapper.append(OthersInputWrap);

    let OthersTextInput = document.createElement("input");
    OthersTextInput.type = "text";
    OthersTextInput.name = "OthersAccommodationType";
    OthersTextInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    OthersTextInput.placeholder = window["BermitraTopMessageTxt1" + window.CurrentCountryID];
    OthersInputWrap.append(OthersTextInput);

    let OthersAccWarning = document.createElement("div");
    OthersAccWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    OthersChoiceWrapper.append(OthersAccWarning);

    let OthersAccWarningImg = document.createElement("img");
    OthersAccWarningImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    OthersAccWarning.append(OthersAccWarningImg);

    let OthersAccWarningText = document.createElement("p");
    OthersAccWarningText.className = "SmallSizeText InterMediumTextFont";
    OthersAccWarningText.innerHTML = window["OtherAccommodationCannotEmptyTxt" + window.CurrentCountryID];
    OthersAccWarning.append(OthersAccWarningText);

    /* Section 1 Button ----------------------------------------------- */

    let Section1Button = document.createElement("button");
    Section1Button.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section1Button.style.margin = "0 auto";
    ChooseYourAcccommodatioMainContainer.append(Section1Button);

    let Section1ButtonText = document.createElement("p");
    Section1ButtonText.className = "InterMediumTextFont";
    Section1ButtonText.innerHTML = window["ContinueTxt" + window.CurrentCountryID];
    Section1Button.append(Section1ButtonText);

    

    // SECTION 2 (ACCOMMODATION NAME) =======================================================================

    let AccommodationNameMainContainer = document.createElement("div");
    AccommodationNameMainContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar";
    AccommodationNameMainContainer.style.display = "none";
    FlexContainerBaseAnimate.append(AccommodationNameMainContainer);

    let AccommodationNameScrollContainer = document.createElement("div");
    AccommodationNameScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer MaskOnlyButton HideScrollBar ThinPaddingWrapper";
    AccommodationNameScrollContainer.style.minHeight = "0";
    AccommodationNameMainContainer.append(AccommodationNameScrollContainer);


    let AccommodationNameInputContainer = document.createElement("div");
    AccommodationNameInputContainer.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    AccommodationNameInputContainer.style.width = "100%";
    AccommodationNameInputContainer.style.minWidth = "100%";
    AccommodationNameInputContainer.style.display = "flex";
    AccommodationNameScrollContainer.append(AccommodationNameInputContainer);

    let AccommodationNameInputField = document.createElement("input");
    AccommodationNameInputField.type = "text";
    AccommodationNameInputField.name = "NamaAkomodasiListing";
    AccommodationNameInputField.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    AccommodationNameInputField.placeholder = window["AccommodationNameSampleTxt" + window.CurrentCountryID];
    AccommodationNameInputContainer.append(AccommodationNameInputField);

    let AccommodationNameWarning = document.createElement("div");
    AccommodationNameWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    AccommodationNameScrollContainer.append(AccommodationNameWarning);

    let AccommodationNameWarningImg = document.createElement("img");
    AccommodationNameWarningImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    AccommodationNameWarning.append(AccommodationNameWarningImg);

    let AccommodationNameWarningText = document.createElement("p");
    AccommodationNameWarningText.className = "SmallSizeText InterMediumTextFont";
    AccommodationNameWarningText.innerHTML = window["AccommodationNameCannotEmptyTxt" + window.CurrentCountryID];
    AccommodationNameWarning.append(AccommodationNameWarningText);


    /* Section 2 Button --------------------------------------------------- */

    let Section2ButtonWrapper = document.createElement("div");
    Section2ButtonWrapper.className = "ColumnGapBasic2";
    Section2ButtonWrapper.style.display = "flex";
    Section2ButtonWrapper.style.margin = "0 auto";
    AccommodationNameMainContainer.append(Section2ButtonWrapper);

    let Section2BtnBack = document.createElement("button");
    Section2BtnBack.className = "MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable";
    Section2ButtonWrapper.append(Section2BtnBack);

    let Section2BtnBackText = document.createElement("p");
    Section2BtnBackText.className = "InterMediumTextFont";
    Section2BtnBackText.innerHTML = window["BackTxt" + window.CurrentCountryID];
    Section2BtnBack.append(Section2BtnBackText);

    let Section2BtnNext = document.createElement("button");
    Section2BtnNext.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section2ButtonWrapper.append(Section2BtnNext);

    let Section2BtnNextText = document.createElement("p");
    Section2BtnNextText.className = "InterMediumTextFont";
    Section2BtnNextText.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    Section2BtnNext.append(Section2BtnNextText);



    // SECTION 3 (ACCOMMODATION LOCATION) =======================================================================

    let Section3AccommodationLocationMainContainer = document.createElement("div");
    Section3AccommodationLocationMainContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar";
    Section3AccommodationLocationMainContainer.style.display = "none";
    FlexContainerBaseAnimate.append(Section3AccommodationLocationMainContainer);

    let Section3AccommodationLocationScrollContainer = document.createElement("div");
    Section3AccommodationLocationScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5";
    Section3AccommodationLocationScrollContainer.style.minHeight = "0";
    Section3AccommodationLocationScrollContainer.style.flexDirection = "column";
    Section3AccommodationLocationScrollContainer.style.display = "flex";
    Section3AccommodationLocationScrollContainer.style.maxHeight = "none";
    Section3AccommodationLocationScrollContainer.style.overflow = "visible";
    Section3AccommodationLocationMainContainer.append(Section3AccommodationLocationScrollContainer);


    /* Province And City Row ------------------------------------------------ */

    let ProvinceNCityRowTop = document.createElement("div");
    ProvinceNCityRowTop.className = "ColumnGapBasic2";
    ProvinceNCityRowTop.style.flex = "1";
    ProvinceNCityRowTop.style.height = "fit-content";
    ProvinceNCityRowTop.style.display = "flex";
    Section3AccommodationLocationScrollContainer.append(ProvinceNCityRowTop);


    let ProvinceWrapper = document.createElement("div"); /* Province ------------------------------------------------ */
    ProvinceWrapper.className = "RowGapBasic4";
    ProvinceWrapper.style.width = "auto";
    ProvinceWrapper.style.minWidth = "0";
    ProvinceWrapper.style.height = "fit-content";
    ProvinceWrapper.style.display = "flex";
    ProvinceWrapper.style.flex = "1";
    ProvinceWrapper.style.flexDirection = "column";
    ProvinceNCityRowTop.append(ProvinceWrapper);

    let ProvinceLabel = document.createElement("p");
    ProvinceLabel.className = "SmallSizeText InterMediumTextFont";
    ProvinceLabel.style.color = "#344054";
    ProvinceLabel.innerHTML = window["ProvinceTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    ProvinceWrapper.append(ProvinceLabel);

    let ProvinceInputWrap = document.createElement("div");
    ProvinceInputWrap.className = "BasicInputFieldContainer";
    ProvinceInputWrap.style.width = "auto";
    ProvinceInputWrap.style.minWidth = "0";
    ProvinceInputWrap.style.display = "flex";
    ProvinceInputWrap.style.flex = "1";
    ProvinceInputWrap.setAttribute("which-province", "");
    ProvinceInputWrap.setAttribute("which-name", "-------");
    ProvinceWrapper.append(ProvinceInputWrap);


    let ProvinceDropdown = document.createElement("div");
    ProvinceDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2";
    ProvinceInputWrap.append(ProvinceDropdown);

    let ProvinceInput = document.createElement("input");
    ProvinceInput.type = "text";
    ProvinceInput.name = "ProvinceInput";
    ProvinceInput.className = "InterMediumTextFont MidSizeText2";
    ProvinceInput.placeholder = "-------";
    ProvinceInput.value = "-------";
    ProvinceDropdown.append(ProvinceInput);

    let ProvinceChevron = document.createElement("img");
    ProvinceChevron.className = "ChevronInsideInput ToggleArrow";
    ProvinceChevron.id = "ListingMitraProvinceChevronBermitra";
    ProvinceChevron.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/chevron.svg";
    ProvinceDropdown.append(ProvinceChevron);

    let ProvinceWarning = document.createElement("div");
    ProvinceWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    ProvinceWrapper.append(ProvinceWarning);

    let ProvinceWarnImg = document.createElement("img");
    ProvinceWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    ProvinceWarning.append(ProvinceWarnImg);

    let ProvinceWarnText = document.createElement("p");
    ProvinceWarnText.className = "SmallSizeText InterMediumTextFont";
    ProvinceWarnText.innerHTML = window["ProvinceCannotEmptyTxt" + window.CurrentCountryID];
    ProvinceWarning.append(ProvinceWarnText);


    let CityWrapper = document.createElement("div"); /* City  ------------------------------------------------ */
    CityWrapper.className = "RowGapBasic4";
    CityWrapper.style.width = "auto";
    CityWrapper.style.minWidth = "0";
    CityWrapper.style.display = "flex";
    CityWrapper.style.flex = "1";
    CityWrapper.style.height = "fit-content";
    CityWrapper.style.flexDirection = "column";
    ProvinceNCityRowTop.append(CityWrapper);

    let CityLabel = document.createElement("p");
    CityLabel.className = "SmallSizeText InterMediumTextFont";
    CityLabel.style.color = "#344054";
    CityLabel.innerHTML = window["CityRegionTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    CityWrapper.append(CityLabel);

    let CityInputWrap = document.createElement("div");
    CityInputWrap.className = "BasicInputFieldContainer InputFieldContainerInvalid";
    CityInputWrap.style.width = "auto";
    CityInputWrap.style.minWidth = "0";
    CityInputWrap.style.display = "flex";
    CityInputWrap.style.flex = "1";
    CityInputWrap.setAttribute("which-city-region", "");
    CityInputWrap.setAttribute("which-name", "-------");
    CityWrapper.append(CityInputWrap);


    let CityDropdown = document.createElement("div");
    CityDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2";
    CityInputWrap.append(CityDropdown);

    let CityInput = document.createElement("input");
    CityInput.type = "text";
    CityInput.name = "CityRegionInput";
    CityInput.className = "InterMediumTextFont MidSizeText2";
    CityInput.placeholder = "-------";
    CityInput.value = "-------";
    CityDropdown.append(CityInput);

    let CityChevron = document.createElement("img");
    CityChevron.className = "ChevronInsideInput ToggleArrow";
    CityChevron.id = "CityRegionChevronBermitra";
    CityChevron.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/chevron.svg";
    CityDropdown.append(CityChevron);

    let CityWarning = document.createElement("div");
    CityWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    CityWrapper.append(CityWarning);

    let CityWarnImg = document.createElement("img");
    CityWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    CityWarning.append(CityWarnImg);

    let CityWarnText = document.createElement("p");
    CityWarnText.className = "SmallSizeText InterMediumTextFont";
    CityWarnText.innerHTML = window["CityRegionCannotEmptyTxt" + window.CurrentCountryID];
    CityWarning.append(CityWarnText);


    /* Alamat/ Full Address ------------------------------------------------ */

    let AlamatLengkapWrapper = document.createElement("div");
    AlamatLengkapWrapper.className = "RowGapBasic4";
    AlamatLengkapWrapper.style.flex = "1";
    AlamatLengkapWrapper.style.height = "fit-content";
    AlamatLengkapWrapper.style.display = "flex";
    AlamatLengkapWrapper.style.flexDirection = "column";
    Section3AccommodationLocationScrollContainer.append(AlamatLengkapWrapper);

    let AlamatLengkapLabel = document.createElement("p");
    AlamatLengkapLabel.className = "SmallSizeText InterMediumTextFont";
    AlamatLengkapLabel.style.color = "#344054";
    AlamatLengkapLabel.innerHTML = window["FullAddressTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    AlamatLengkapWrapper.append(AlamatLengkapLabel);

    let AlamatLengkapInputWrap = document.createElement("div");
    AlamatLengkapInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    AlamatLengkapInputWrap.style.width = "100%";
    AlamatLengkapInputWrap.style.minWidth = "100%";
    AlamatLengkapInputWrap.style.display = "flex";
    AlamatLengkapWrapper.append(AlamatLengkapInputWrap);

    let AlamatLengkapInput = document.createElement("input");
    AlamatLengkapInput.type = "text";
    AlamatLengkapInput.name = "FullAddress";
    AlamatLengkapInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    AlamatLengkapInput.placeholder = window["FullAddressPlaceholderTxt" + window.CurrentCountryID];
    AlamatLengkapInputWrap.append(AlamatLengkapInput);

    let AlamatLengkapWarningWrapper = document.createElement("div");
    AlamatLengkapWarningWrapper.className = "WarningTextImgWrapper ColumnGapBasic4";
    AlamatLengkapWrapper.append(AlamatLengkapWarningWrapper);

    let AlamatLengkapWarningImg = document.createElement("img");
    AlamatLengkapWarningImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    AlamatLengkapWarningWrapper.append(AlamatLengkapWarningImg);

    let AlamatLengkapWarningText = document.createElement("p");
    AlamatLengkapWarningText.className = "SmallSizeText InterMediumTextFont";
    AlamatLengkapWarningText.innerHTML = window["FullAddressCannotEmptyTxt" + window.CurrentCountryID];
    AlamatLengkapWarningWrapper.append(AlamatLengkapWarningText);




    /* Google Maps ------------------------------------------------ */

    let GoogleMapsURLWrapper = document.createElement("div");
    GoogleMapsURLWrapper.className = "RowGapBasic4";
    GoogleMapsURLWrapper.style.flex = "1";
    GoogleMapsURLWrapper.style.height = "fit-content";
    GoogleMapsURLWrapper.style.display = "flex";
    GoogleMapsURLWrapper.style.flexDirection = "column";
    Section3AccommodationLocationScrollContainer.append(GoogleMapsURLWrapper);

    let GoogleMapsURLLabel = document.createElement("p");
    GoogleMapsURLLabel.className = "SmallSizeText InterMediumTextFont";
    GoogleMapsURLLabel.style.color = "#344054";
    GoogleMapsURLLabel.innerHTML = window["GoogleMapsUrlTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    GoogleMapsURLWrapper.append(GoogleMapsURLLabel);

    let GoogleMapsURLInputWrap = document.createElement("div");
    GoogleMapsURLInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    GoogleMapsURLInputWrap.style.width = "100%";
    GoogleMapsURLInputWrap.style.minWidth = "100%";
    GoogleMapsURLInputWrap.style.display = "flex";
    GoogleMapsURLWrapper.append(GoogleMapsURLInputWrap);

    let GoogleMapsURLInput = document.createElement("input");
    GoogleMapsURLInput.type = "url";
    GoogleMapsURLInput.name = "GoogleMapsURL";
    GoogleMapsURLInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    GoogleMapsURLInput.placeholder = window["GoogleMapPlaceholderTxt" + window.CurrentCountryID];
    GoogleMapsURLInputWrap.append(GoogleMapsURLInput);

    let GoogleMapsURLWarning = document.createElement("div");
    GoogleMapsURLWarning.className = "WarningTextImgWrapper ColumnGapBasic";
    GoogleMapsURLWrapper.append(GoogleMapsURLWarning);

    let GoogleMapsURLWarnImg = document.createElement("img");
    GoogleMapsURLWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    GoogleMapsURLWarning.append(GoogleMapsURLWarnImg);

    let GoogleMapsURLWarnText = document.createElement("p");
    GoogleMapsURLWarnText.className = "SmallSizeText InterMediumTextFont";
    GoogleMapsURLWarnText.innerHTML = window["GoogleMapsUrlCannotEmptyTxt" + window.CurrentCountryID];
    GoogleMapsURLWarning.append(GoogleMapsURLWarnText);




    /* Section 3 Button ----------------------------------------------- */

    let Section3ButtonWrapper = document.createElement("div");
    Section3ButtonWrapper.className = "ColumnGapBasic2";
    Section3ButtonWrapper.style.display = "flex";
    Section3ButtonWrapper.style.margin = "0 auto";
    Section3AccommodationLocationMainContainer.append(Section3ButtonWrapper);

    let Section3BackButton = document.createElement("button");
    Section3BackButton.className = "MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable";
    Section3ButtonWrapper.append(Section3BackButton);

    let Section3BackButtonText = document.createElement("p");
    Section3BackButtonText.className = "InterMediumTextFont";
    Section3BackButtonText.innerHTML = window["BackTxt" + window.CurrentCountryID];
    Section3BackButton.append(Section3BackButtonText);

    let Section3NextButton = document.createElement("button");
    Section3NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section3ButtonWrapper.append(Section3NextButton);

    let Section3NextButtonText = document.createElement("p");
    Section3NextButtonText.className = "InterMediumTextFont";
    Section3NextButtonText.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    Section3NextButton.append(Section3NextButtonText);


    
    // SECTION 4 (ACCOMMODATION IMAGE AND SOCIAL) =======================================================================

    let Section4AccSocialAndImageContainer = document.createElement("div");
    Section4AccSocialAndImageContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar";
    Section4AccSocialAndImageContainer.style.display = "none";
    FlexContainerBaseAnimate.append(Section4AccSocialAndImageContainer);

    let Section4AccSocialAndImageScrollContainer = document.createElement("div");
    Section4AccSocialAndImageScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5";
    Section4AccSocialAndImageScrollContainer.style.minHeight = "0";
    Section4AccSocialAndImageScrollContainer.style.flexDirection = "column";
    Section4AccSocialAndImageScrollContainer.style.display = "flex";
    Section4AccSocialAndImageContainer.append(Section4AccSocialAndImageScrollContainer);


    /* Input Acc Photo ----------------------------------------------- */

    let AccommodationPhotoHeader = document.createElement("div");
    AccommodationPhotoHeader.className = "RowGapBasic4";
    AccommodationPhotoHeader.style.flex = "1";
    AccommodationPhotoHeader.style.height = "fit-content";
    AccommodationPhotoHeader.style.display = "flex";
    AccommodationPhotoHeader.style.flexDirection = "column";
    Section4AccSocialAndImageScrollContainer.append(AccommodationPhotoHeader);

    let AccPhotoHeaderText = document.createElement("p");
    AccPhotoHeaderText.className = "MidSizeText InterBoldTextFont";
    AccPhotoHeaderText.style.color = "#344054";
    AccPhotoHeaderText.innerHTML = window["AccPhotosTxt" + window.CurrentCountryID] + ' <span class="InterMediumTextFont" style="color: #c10000">*</span>';
    AccommodationPhotoHeader.append(AccPhotoHeaderText);

    let AccPhotoDescText = document.createElement("p");
    AccPhotoDescText.className = "SmallSizeText InterMediumTextFont";
    AccPhotoDescText.style.color = "rgb(109, 109, 109)";
    AccPhotoDescText.innerHTML = window["AddPhotoRuleAndLimitTxt" + window.CurrentCountryID];
    AccommodationPhotoHeader.append(AccPhotoDescText);


    let AccPhotoUploadBox = document.createElement("div"); /* Drop or Button Upload ---------- */
    AccPhotoUploadBox.className = "BlueStripBorder WhiteContentWrapperPadding BasicRadius ContainerHoverable";
    AccPhotoUploadBox.style.cursor = "pointer";
    AccPhotoUploadBox.style.width = "auto";
    AccPhotoUploadBox.style.height = "fit-content";
    Section4AccSocialAndImageScrollContainer.append(AccPhotoUploadBox);

    let AccPhotoUploadInner = document.createElement("div");
    AccPhotoUploadInner.className = "ContentHovTarget";
    AccPhotoUploadInner.id = "UploadPhotoHereContentWrapper";
    AccPhotoUploadInner.style.width = "fit-content";
    AccPhotoUploadInner.style.height = "fit-content";
    AccPhotoUploadInner.style.display = "flex";
    AccPhotoUploadInner.style.flexDirection = "column";
    AccPhotoUploadInner.style.margin = "auto";
    AccPhotoUploadBox.append(AccPhotoUploadInner);

    let AccPhotoUploadIcon = document.createElement("img");
    AccPhotoUploadIcon.className = "BiggestSizeIcon";
    AccPhotoUploadIcon.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/upload-cloud-blue.svg";
    AccPhotoUploadIcon.style.margin = "0 auto";
    AccPhotoUploadInner.append(AccPhotoUploadIcon);

    let AccPhotoUploadText = document.createElement("p");
    AccPhotoUploadText.className = "SpecialMidSizeText3 RobotoBoldTextFont";
    AccPhotoUploadText.style.color = "rgb(11, 11, 11)";
    AccPhotoUploadText.style.margin = "0 auto";
    AccPhotoUploadText.innerHTML = window["DragYourFileOrInputTxt" + window.CurrentCountryID];
    AccPhotoUploadInner.append(AccPhotoUploadText);

    let AccPhotoUploadDesc = document.createElement("p");
    AccPhotoUploadDesc.className = "SmallSizeText RobotoTextFont";
    AccPhotoUploadDesc.style.margin = "0 auto";
    AccPhotoUploadDesc.style.color = "rgb(109, 109, 109)";
    AccPhotoUploadDesc.innerHTML = window["Max10MBFilesAllowedTxt" + window.CurrentCountryID];
    AccPhotoUploadInner.append(AccPhotoUploadDesc);

    let ImageInputFieldHide = document.createElement("input");
    ImageInputFieldHide.type = "file";
    ImageInputFieldHide.accept = ".jpg, .png, .jpeg";
    ImageInputFieldHide.style.display = "none";
    ImageInputFieldHide.multiple = true;
    Section4AccSocialAndImageScrollContainer.append(ImageInputFieldHide);


    let AccPhotoSwiperContainer = document.createElement("div"); /* Uploaded Photo Swiper ---------- */
    AccPhotoSwiperContainer.className = "ListOfUploadedPhotoSwiperContainer";
    Section4AccSocialAndImageScrollContainer.append(AccPhotoSwiperContainer);

    let AccPhotoSwiperWrapper = document.createElement("div");
    AccPhotoSwiperWrapper.className = "swiper-wrapper";
    AccPhotoSwiperContainer.append(AccPhotoSwiperWrapper);

    let UploadedPhotoSwiper = new window.Swiper(AccPhotoSwiperContainer,
    {
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true
    });


    /* Social Media URL ----------------------------------------------- */

    let SocialMediaTextWrapper = document.createElement("div");
    SocialMediaTextWrapper.className = "RowGapBasic4";
    SocialMediaTextWrapper.style.flex = "1";
    SocialMediaTextWrapper.style.display = "flex";
    SocialMediaTextWrapper.style.flexDirection = "column";
    Section4AccSocialAndImageScrollContainer.append(SocialMediaTextWrapper);

    let SocialMediaHeaderText = document.createElement("p");
    SocialMediaHeaderText.className = "MidSizeText InterBoldTextFont";
    SocialMediaHeaderText.style.color = "#344054";
    SocialMediaHeaderText.innerHTML = window["AccSocialMediaTxt" + window.CurrentCountryID] + ' <span class="InterMediumTextFont" style="color: #c10000">*</span>';
    SocialMediaTextWrapper.append(SocialMediaHeaderText);

    let SocialMediaDescText = document.createElement("p");
    SocialMediaDescText.className = "SmallSizeText InterMediumTextFont";
    SocialMediaDescText.style.color = "rgb(109, 109, 109)";
    SocialMediaDescText.innerHTML = window["AddYourAccSocialMediaTxt" + window.CurrentCountryID];
    SocialMediaTextWrapper.append(SocialMediaDescText);

    
    let InstagramWrapper = document.createElement("div"); /* Instagram ---------- */
    InstagramWrapper.className = "RowGapBasic4";
    InstagramWrapper.style.display = "flex";
    InstagramWrapper.style.flexDirection = "column";
    Section4AccSocialAndImageScrollContainer.append(InstagramWrapper);

    let InstagramLabel = document.createElement("p");
    InstagramLabel.className = "SmallSizeText InterMediumTextFont";
    InstagramLabel.style.color = "#344054";
    InstagramLabel.innerHTML = window["InstagramTxt" + window.CurrentCountryID];
    InstagramWrapper.append(InstagramLabel);

    let InstagramInputWrap = document.createElement("div");
    InstagramInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    InstagramInputWrap.style.display = "flex";
    InstagramWrapper.append(InstagramInputWrap);

    let InstagramInner = document.createElement("div");
    InstagramInner.className = "InputFieldPadding ColumnGapBasic";
    InstagramInner.style.display = "flex";
    InstagramInputWrap.append(InstagramInner);

    let InstagramIcon = document.createElement("img");
    InstagramIcon.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/Social/ig-instagram-icon.svg";
    InstagramIcon.className = "BigSizeIcon";
    InstagramInner.append(InstagramIcon);

    let InstagramInput = document.createElement("input");
    InstagramInput.type = "url";
    InstagramInput.name = "InstagramURL";
    InstagramInput.className = "MidSizeText2 InterMediumTextFont";
    InstagramInput.placeholder = window["InstagramPlaceholderTxt" + window.CurrentCountryID];
    InstagramInput.style.flex = "1";
    InstagramInner.append(InstagramInput);

    let InstagramWarning = document.createElement("div");
    InstagramWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    InstagramWrapper.append(InstagramWarning);

    let InstagramWarningImg = document.createElement("img");
    InstagramWarningImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    InstagramWarning.append(InstagramWarningImg);

    let InstagramWarningText = document.createElement("p");
    InstagramWarningText.className = "SmallSizeText InterMediumTextFont";
    InstagramWarningText.innerHTML = window["InstagramEmptyTxt" + window.CurrentCountryID];
    InstagramWarning.append(InstagramWarningText);


    let TiktokWrapper = document.createElement("div"); /* Tiktok ---------- */
    TiktokWrapper.className = "RowGapBasic4";
    TiktokWrapper.style.display = "flex";
    TiktokWrapper.style.flexDirection = "column";
    Section4AccSocialAndImageScrollContainer.append(TiktokWrapper);

    let TiktokLabel = document.createElement("p");
    TiktokLabel.className = "SmallSizeText InterMediumTextFont";
    TiktokLabel.style.color = "#344054";
    TiktokLabel.innerHTML = window["TikTokTxt" + window.CurrentCountryID];
    TiktokWrapper.append(TiktokLabel);

    let TiktokInputWrap = document.createElement("div");
    TiktokInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    TiktokInputWrap.style.display = "flex";
    TiktokWrapper.append(TiktokInputWrap);

    let TiktokInner = document.createElement("div");
    TiktokInner.className = "InputFieldPadding ColumnGapBasic";
    TiktokInner.style.display = "flex";
    TiktokInputWrap.append(TiktokInner);

    let TiktokIcon = document.createElement("img");
    TiktokIcon.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/Social/tiktok-square-color-icon.svg";
    TiktokIcon.className = "BigSizeIcon";
    TiktokInner.append(TiktokIcon);

    let TiktokInput = document.createElement("input");
    TiktokInput.type = "url";
    TiktokInput.name = "TiktokURL";
    TiktokInput.className = "MidSizeText2 InterMediumTextFont";
    TiktokInput.placeholder = window["TikTokPlaceholderTxt" + window.CurrentCountryID];
    TiktokInput.style.flex = "1";
    TiktokInner.append(TiktokInput);

    let TiktokWarning = document.createElement("div");
    TiktokWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    TiktokWrapper.append(TiktokWarning);

    let TiktokWarningImg = document.createElement("img");
    TiktokWarningImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    TiktokWarning.append(TiktokWarningImg);

    let TiktokWarningText = document.createElement("p");
    TiktokWarningText.className = "SmallSizeText InterMediumTextFont";
    TiktokWarningText.innerHTML = window["TikTokEmptyTxt" + window.CurrentCountryID];
    TiktokWarning.append(TiktokWarningText);


    /* Section 4 Button ----------------------------------------------- */
    let Section4ButtonWrapper = document.createElement("div");
    Section4ButtonWrapper.className = "ColumnGapBasic2";
    Section4ButtonWrapper.style.display = "flex";
    Section4ButtonWrapper.style.margin = "0 auto";
    Section4AccSocialAndImageContainer.append(Section4ButtonWrapper);

    let Section4BackButton = document.createElement("button");
    Section4BackButton.className = "MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable";
    Section4ButtonWrapper.append(Section4BackButton);

    let Section4BackButtonText = document.createElement("p");
    Section4BackButtonText.className = "InterMediumTextFont";
    Section4BackButtonText.innerHTML = window["BackTxt" + window.CurrentCountryID];
    Section4BackButton.append(Section4BackButtonText);

    let Section4NextButton = document.createElement("button");
    Section4NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section4ButtonWrapper.append(Section4NextButton);

    let Section4NextButtonText = document.createElement("p");
    Section4NextButtonText.className = "InterMediumTextFont";
    Section4NextButtonText.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    Section4NextButton.append(Section4NextButtonText);




    // SECTION 5 (ACCOMMODATION PRICE AND QUANTITY) =======================================================================

    let Section5AccPriceQuantContainer = document.createElement("div");
    Section5AccPriceQuantContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar";
    Section5AccPriceQuantContainer.style.display = "none";
    FlexContainerBaseAnimate.append(Section5AccPriceQuantContainer);

    let Section5AccPriceQuantScrollContainer = document.createElement("div");
    Section5AccPriceQuantScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5";
    Section5AccPriceQuantScrollContainer.style.minHeight = "0";
    Section5AccPriceQuantScrollContainer.style.flexDirection = "column";
    Section5AccPriceQuantScrollContainer.style.display = "flex";
    Section5AccPriceQuantContainer.append(Section5AccPriceQuantScrollContainer);


    /* Jumlah Kamar ----------------------------------------------- */

    let RoomQuantityWrapper = document.createElement("div");
    RoomQuantityWrapper.className = "RowGapBasic4";
    RoomQuantityWrapper.style.flex = "1";
    RoomQuantityWrapper.style.height = "fit-content";
    RoomQuantityWrapper.style.display = "flex";
    RoomQuantityWrapper.style.flexDirection = "column";
    Section5AccPriceQuantScrollContainer.append(RoomQuantityWrapper);

    let RoomQuantityLabel = document.createElement("p");
    RoomQuantityLabel.className = "SmallSizeText InterMediumTextFont";
    RoomQuantityLabel.style.color = "#344054";
    RoomQuantityLabel.innerHTML = window["TotalRoomsTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    RoomQuantityWrapper.append(RoomQuantityLabel);

    let RoomQuantityInputWrap = document.createElement("div");
    RoomQuantityInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    RoomQuantityInputWrap.style.width = "100%";
    RoomQuantityInputWrap.style.minWidth = "100%";
    RoomQuantityInputWrap.style.display = "flex";
    RoomQuantityWrapper.append(RoomQuantityInputWrap);

    let RoomQuantityInput = document.createElement("input");
    RoomQuantityInput.type = "number";
    RoomQuantityInput.name = "RoomQuantity";
    RoomQuantityInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    RoomQuantityInput.placeholder = window["TotalPlaceholderTxt" + window.CurrentCountryID];
    RoomQuantityInputWrap.append(RoomQuantityInput);

    let RoomQuantityWarning = document.createElement("div");
    RoomQuantityWarning.className = "WarningTextImgWrapper ColumnGapBasic4";
    RoomQuantityWrapper.append(RoomQuantityWarning);

    let RoomQuantityWarnImg = document.createElement("img");
    RoomQuantityWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    RoomQuantityWarning.append(RoomQuantityWarnImg);

    let RoomQuantityWarnText = document.createElement("p");
    RoomQuantityWarnText.className = "SmallSizeText InterMediumTextFont";
    RoomQuantityWarnText.innerHTML = window["TotalRoomsCannotEmptyTxt" + window.CurrentCountryID];
    RoomQuantityWarning.append(RoomQuantityWarnText);



    /* Price From and To ----------------------------------------------- */

    let PriceFromandToMainContainer = document.createElement("div");
    PriceFromandToMainContainer.className = "RowGapBasic4";
    PriceFromandToMainContainer.style.flex = "1";
    PriceFromandToMainContainer.style.height = "fit-content";
    PriceFromandToMainContainer.style.display = "flex";
    PriceFromandToMainContainer.style.flexDirection = "column";
    Section5AccPriceQuantScrollContainer.append(PriceFromandToMainContainer);

    let RoomPriceLabelText = document.createElement("p");
    RoomPriceLabelText.className = "SmallSizeText InterMediumTextFont";
    RoomPriceLabelText.style.color = "#344054";
    RoomPriceLabelText.innerHTML = window["RoomRatesTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    PriceFromandToMainContainer.append(RoomPriceLabelText);

    let PriceFromandToWrapper = document.createElement("div");
    PriceFromandToWrapper.className = "ColumnGapBasic";
    PriceFromandToWrapper.style.flex = "1";
    PriceFromandToWrapper.style.height = "fit-content";
    PriceFromandToWrapper.style.display = "flex";
    PriceFromandToMainContainer.append(PriceFromandToWrapper);


    let PriceFromWrapper = document.createElement("div"); /* Price From ---------------- */
    PriceFromWrapper.className = "RowGapBasic4";
    PriceFromWrapper.style.width = "auto";
    PriceFromWrapper.style.minWidth = "0";
    PriceFromWrapper.style.display = "flex";
    PriceFromWrapper.style.flex = "1";
    PriceFromWrapper.style.flexDirection = "column";
    PriceFromandToWrapper.append(PriceFromWrapper);

    let PriceFromInputWrap = document.createElement("div");
    PriceFromInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
    PriceFromInputWrap.style.width = "100%";
    PriceFromInputWrap.style.minWidth = "100%";
    PriceFromInputWrap.style.display = "flex";
    PriceFromWrapper.append(PriceFromInputWrap);

    let PriceFromPrefix = document.createElement("div");
    PriceFromPrefix.className = "SmallTextContainerInsideInputField BasicRadius";
    PriceFromInputWrap.append(PriceFromPrefix);

    let PriceFromPrefixText = document.createElement("p");
    PriceFromPrefixText.className = "MidSizeText2 InterMediumTextFont";
    PriceFromPrefixText.style.color = "#667085";
    PriceFromPrefixText.innerHTML = "Rp";
    PriceFromPrefix.append(PriceFromPrefixText);

    let PriceFromInput = document.createElement("input");
    PriceFromInput.type = "number";
    PriceFromInput.name = "RoomPriceFrom";
    PriceFromInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    PriceFromInput.placeholder = "100,000";
    PriceFromInputWrap.append(PriceFromInput);


    let PriceUntilText = document.createElement("p");  /* Until Text ---------------- */
    PriceUntilText.className = "SmallSizeText InterMediumTextFont";
    PriceUntilText.style.color = "#344054";
    PriceUntilText.style.margin = "auto 0";
    PriceUntilText.innerHTML = window["ToTxt" + window.CurrentCountryID];
    PriceFromandToWrapper.append(PriceUntilText);

    let PriceToWrapper = document.createElement("div");  /* Price To ---------------- */
    PriceToWrapper.className = "RowGapBasic4";
    PriceToWrapper.style.width = "auto";
    PriceToWrapper.style.minWidth = "0";
    PriceToWrapper.style.display = "flex";
    PriceToWrapper.style.flex = "1";
    PriceToWrapper.style.flexDirection = "column";
    PriceFromandToWrapper.append(PriceToWrapper);

    let PriceToInputWrap = document.createElement("div");
    PriceToInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
    PriceToInputWrap.style.width = "100%";
    PriceToInputWrap.style.minWidth = "100%";
    PriceToInputWrap.style.display = "flex";
    PriceToWrapper.append(PriceToInputWrap);

    let PriceToPrefix = document.createElement("div");
    PriceToPrefix.className = "SmallTextContainerInsideInputField BasicRadius";
    PriceToInputWrap.append(PriceToPrefix);

    let PriceToPrefixText = document.createElement("p");
    PriceToPrefixText.className = "MidSizeText2 InterMediumTextFont";
    PriceToPrefixText.style.color = "#667085";
    PriceToPrefixText.innerHTML = "Rp";
    PriceToPrefix.append(PriceToPrefixText);

    let PriceToInput = document.createElement("input");
    PriceToInput.type = "number";
    PriceToInput.name = "RoomPriceTo";
    PriceToInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    PriceToInput.placeholder = "1,000,000";
    PriceToInputWrap.append(PriceToInput);

    
    let RoomPriceWrapper = document.createElement("div");
    RoomPriceWrapper.className = "WarningTextImgWrapper ColumnGapBasic4";
    PriceFromandToMainContainer.append(RoomPriceWrapper);

    let RoomPriceImg = document.createElement("img");
    RoomPriceImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    RoomPriceWrapper.append(RoomPriceImg);

    let RoomPriceText = document.createElement("p");
    RoomPriceText.className = "SmallSizeText InterMediumTextFont";
    RoomPriceText.innerHTML = window["MinRoomRatesCannotEmptyTxt" + window.CurrentCountryID];
    RoomPriceWrapper.append(RoomPriceText);



    /* Section 5 Button ----------------------------------------------- */

    let Section5ButtonWrapper = document.createElement("div");
    Section5ButtonWrapper.className = "ColumnGapBasic2";
    Section5ButtonWrapper.style.display = "flex";
    Section5ButtonWrapper.style.margin = "0 auto";
    Section5AccPriceQuantContainer.append(Section5ButtonWrapper);

    let Section5BackButton = document.createElement("button");
    Section5BackButton.className = "MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable";
    Section5ButtonWrapper.append(Section5BackButton);

    let Section5BackButtonText = document.createElement("p");
    Section5BackButtonText.className = "InterMediumTextFont";
    Section5BackButtonText.innerHTML = window["BackTxt" + window.CurrentCountryID];
    Section5BackButton.append(Section5BackButtonText);

    let Section5NextButton = document.createElement("button");
    Section5NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section5ButtonWrapper.append(Section5NextButton);

    let Section5NextButtonText = document.createElement("p");
    Section5NextButtonText.className = "InterMediumTextFont";
    Section5NextButtonText.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    Section5NextButton.append(Section5NextButtonText);


    // SECTION 6 (ACCOMMODATION PRICE AND QUANTITY) =======================================================================

    let Section6UserInfoContainer = document.createElement("div");
    Section6UserInfoContainer.className = "BasicSizePopUpPanelWrapper RowGapBasic5 HideScrollBar";
    Section6UserInfoContainer.style.display = "none";
    FlexContainerBaseAnimate.append(Section6UserInfoContainer);

    let Section6UserInfoScrollContainer = document.createElement("div");
    Section6UserInfoScrollContainer.className = "BasicScrollableContainer MidHeightScrollMaxContainer HideScrollBar ThinPaddingWrapper RowGapBasic5";
    Section6UserInfoScrollContainer.style.minHeight = "0";
    Section6UserInfoScrollContainer.style.flexDirection = "column";
    Section6UserInfoScrollContainer.style.display = "flex";
    Section6UserInfoScrollContainer.style.maxHeight = "none";
    Section6UserInfoScrollContainer.style.overflow = "visible";
    Section6UserInfoContainer.append(Section6UserInfoScrollContainer);


    /* Name and City Region ----------------------------------------------- */

    let NameandCityRegionWrapper = document.createElement("div");
    NameandCityRegionWrapper.className = "ColumnGapBasic2";
    NameandCityRegionWrapper.style.flex = "1";
    NameandCityRegionWrapper.style.display = "flex";
    Section6UserInfoScrollContainer.append(NameandCityRegionWrapper);

    
    let UsernameWrap = document.createElement("div"); /* Name --------------------------- */
    UsernameWrap.className = "RowGapBasic4";
    UsernameWrap.style.flex = "1";
    UsernameWrap.style.display = "flex";
    UsernameWrap.style.flexDirection = "column";
    NameandCityRegionWrapper.append(UsernameWrap);

    let UsernameLabel = document.createElement("p");
    UsernameLabel.className = "SmallSizeText InterMediumTextFont";
    UsernameLabel.style.color = "#344054";
    UsernameLabel.innerHTML = window["FullNameTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    UsernameWrap.append(UsernameLabel);

    let UsernameInputWrap = document.createElement("div");
    UsernameInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    UsernameInputWrap.style.display = "flex";
    UsernameWrap.append(UsernameInputWrap);

    let UsernameInput = document.createElement("input");
    UsernameInput.type = "text";
    UsernameInput.name = "FullName";
    UsernameInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    UsernameInput.placeholder = window["InputFullNamePlaceholderTxt" + window.CurrentCountryID];
    UsernameInputWrap.append(UsernameInput);

    let UsernameWarn = document.createElement("div");
    UsernameWarn.className = "WarningTextImgWrapper ColumnGapBasic4";
    UsernameWrap.append(UsernameWarn);

    let UsernameWarnImg = document.createElement("img");
    UsernameWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    UsernameWarn.append(UsernameWarnImg);

    let UsernameWarnText = document.createElement("p");
    UsernameWarnText.className = "SmallSizeText InterMediumTextFont";
    UsernameWarnText.innerHTML = window["FullNameCannotEmptyTxt" + window.CurrentCountryID];
    UsernameWarn.append(UsernameWarnText);


    let GenderMainWrapper = document.createElement("div"); /* Gender --------------------------- */
    GenderMainWrapper.className = "RowGapBasic4";
    GenderMainWrapper.style.flex = "1";
    GenderMainWrapper.style.height = "fit-content";
    GenderMainWrapper.style.display = "flex";
    GenderMainWrapper.style.flexDirection = "column";
    NameandCityRegionWrapper.append(GenderMainWrapper);

    let GenderMainLabelText = document.createElement("p");
    GenderMainLabelText.className = "SmallSizeText InterMediumTextFont";
    GenderMainLabelText.style.color = "#344054";
    GenderMainLabelText.innerHTML = window["GenderHeaderTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    GenderMainWrapper.append(GenderMainLabelText);

    let GenderDropDownMainContainer = document.createElement("div");
    GenderDropDownMainContainer.className = "BasicInputFieldContainer";
    GenderDropDownMainContainer.style.display = "flex";
    GenderDropDownMainContainer.style.flex = "1";
    GenderDropDownMainContainer.setAttribute("which-gender", "Male");
    GenderMainWrapper.append(GenderDropDownMainContainer);

    let GenderDropDownWrapper = document.createElement("div");
    GenderDropDownWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2";
    GenderDropDownMainContainer.append(GenderDropDownWrapper);

    let GenderDropDownInput = document.createElement("input");
    GenderDropDownInput.type = "text";
    GenderDropDownInput.className = "InterMediumTextFont MidSizeText2";
    GenderDropDownInput.placeholder = "-------";
    GenderDropDownInput.value = window.GenderChoicesJSON[0].translation[window.CurrentCountryID];
    GenderDropDownWrapper.append(GenderDropDownInput);

    let GenderDropDownChevron = document.createElement("img");
    GenderDropDownChevron.className = "ChevronInsideInput ToggleArrow";
    GenderDropDownChevron.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/chevron.svg";
    GenderDropDownWrapper.append(GenderDropDownChevron);


    /* Department ----------------------------------------------- */

    let DepartmentWrap = document.createElement("div");
    DepartmentWrap.className = "RowGapBasic4";
    DepartmentWrap.style.display = "flex";
    DepartmentWrap.style.flexDirection = "column";
    Section6UserInfoScrollContainer.append(DepartmentWrap);

    let DepartmentLabel = document.createElement("p");
    DepartmentLabel.className = "SmallSizeText InterMediumTextFont";
    DepartmentLabel.style.color = "#344054";
    DepartmentLabel.innerHTML = window["DepartmentTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    DepartmentWrap.append(DepartmentLabel);

    let DepartmentInputWrap = document.createElement("div");
    DepartmentInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    DepartmentInputWrap.style.display = "flex";
    DepartmentWrap.append(DepartmentInputWrap);

    let DepartmentInput = document.createElement("input");
    DepartmentInput.type = "text";
    DepartmentInput.name = "DepartmentName";
    DepartmentInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    DepartmentInput.placeholder = window["DepartmentPlaceholderTxt" + window.CurrentCountryID];
    DepartmentInputWrap.append(DepartmentInput);

    let DepartmentWarn = document.createElement("div");
    DepartmentWarn.className = "WarningTextImgWrapper ColumnGapBasic4";
    DepartmentWrap.append(DepartmentWarn);

    let DepartmentWarnImg = document.createElement("img");
    DepartmentWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    DepartmentWarn.append(DepartmentWarnImg);

    let DepartmentWarnText = document.createElement("p");
    DepartmentWarnText.className = "SmallSizeText InterMediumTextFont";
    DepartmentWarnText.innerHTML = window["DepartmentCannotEmptyTxt" + window.CurrentCountryID];
    DepartmentWarn.append(DepartmentWarnText);


    /* Email ----------------------------------------------- */

    let EmailWrap = document.createElement("div");
    EmailWrap.className = "RowGapBasic4";
    EmailWrap.style.display = "flex";
    EmailWrap.style.flexDirection = "column";
    Section6UserInfoScrollContainer.append(EmailWrap);

    let EmailLabel = document.createElement("p");
    EmailLabel.className = "SmallSizeText InterMediumTextFont";
    EmailLabel.style.color = "#344054";
    EmailLabel.innerHTML = window["EmailTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    EmailWrap.append(EmailLabel);

    let EmailInputWrap = document.createElement("div");
    EmailInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
    EmailInputWrap.style.display = "flex";
    EmailWrap.append(EmailInputWrap);

    let EmailInput = document.createElement("input");
    EmailInput.type = "email";
    EmailInput.name = "Email";
    EmailInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    EmailInput.placeholder = window["SampleEmailPlaceholder" + window.CurrentCountryID];
    EmailInputWrap.append(EmailInput);


    let EmailWarn = document.createElement("div");
    EmailWarn.className = "WarningTextImgWrapper ColumnGapBasic4";
    EmailWrap.append(EmailWarn);

    let EmailWarnImg = document.createElement("img");
    EmailWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    EmailWarn.append(EmailWarnImg);

    let EmailWarnText = document.createElement("p");
    EmailWarnText.className = "SmallSizeText InterMediumTextFont";
    EmailWarnText.innerHTML = window["EmailCannotEmptyTxt" + window.CurrentCountryID];
    EmailWarn.append(EmailWarnText);

    /* Phone Number ----------------------------------------------- */

    let PhoneNumberWrap = document.createElement("div");
    PhoneNumberWrap.className = "RowGapBasic4";
    PhoneNumberWrap.style.display = "flex";
    PhoneNumberWrap.style.flexDirection = "column";
    Section6UserInfoScrollContainer.append(PhoneNumberWrap);

    let PhoneNumberLabel = document.createElement("p");
    PhoneNumberLabel.className = "SmallSizeText InterMediumTextFont";
    PhoneNumberLabel.style.color = "#344054";
    PhoneNumberLabel.innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    PhoneNumberWrap.append(PhoneNumberLabel);

    let PhoneNumberInputWrap = document.createElement("div");
    PhoneNumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
    PhoneNumberInputWrap.style.display = "flex";
    PhoneNumberWrap.append(PhoneNumberInputWrap);

    let PhoneNumberPrefix = document.createElement("div");
    PhoneNumberPrefix.className = "SmallTextContainerInsideInputField BasicRadius ColumnGapBasic";
    PhoneNumberInputWrap.append(PhoneNumberPrefix);

    let PhoneNumberIcon = document.createElement("img");
    PhoneNumberIcon.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/phone-black.svg";
    PhoneNumberIcon.className = "MidSizeIcon";
    PhoneNumberPrefix.append(PhoneNumberIcon);

    let PhoneNumberCode = document.createElement("p");
    PhoneNumberCode.className = "MidSizeText2 InterMediumTextFont";
    PhoneNumberCode.style.color = "#667085";
    PhoneNumberCode.innerHTML = "+62";
    PhoneNumberPrefix.append(PhoneNumberCode);

    let PhoneNumberInput = document.createElement("input");
    PhoneNumberInput.type = "number";
    PhoneNumberInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    PhoneNumberInput.placeholder = "8123456789";
    PhoneNumberInputWrap.append(PhoneNumberInput);

    let PhoneNumberWarn = document.createElement("div");
    PhoneNumberWarn.className = "WarningTextImgWrapper ColumnGapBasic4";
    PhoneNumberWrap.append(PhoneNumberWarn);

    let PhoneNumberWarnImg = document.createElement("img");
    PhoneNumberWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    PhoneNumberWarn.append(PhoneNumberWarnImg);

    let PhoneNumberWarnText = document.createElement("p");
    PhoneNumberWarnText.className = "SmallSizeText InterMediumTextFont";
    PhoneNumberWarnText.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
    PhoneNumberWarn.append(PhoneNumberWarnText);


    /* WhatsApp Toggle ----------------------------------------------- */

    let WhatsAppToggleWrap = document.createElement("div");
    WhatsAppToggleWrap.className = "ColumnGapBasic4";
    WhatsAppToggleWrap.style.display = "flex";
    PhoneNumberWrap.append(WhatsAppToggleWrap);

    let WhatsAppToggleLabel = document.createElement("label");
    WhatsAppToggleLabel.className = "BasicToggleSwitch";
    WhatsAppToggleLabel.style.margin = "auto 0";
    WhatsAppToggleWrap.append(WhatsAppToggleLabel);

    let WhatsAppToggleInput = document.createElement("input");
    WhatsAppToggleInput.type = "checkbox";
    WhatsAppToggleInput.id = "PhoneWhatsAppToggleCheckBox";
    WhatsAppToggleInput.checked = true;
    WhatsAppToggleLabel.append(WhatsAppToggleInput);

    let WhatsAppToggleSpan = document.createElement("span");
    WhatsAppToggleSpan.className = "slider round";
    WhatsAppToggleLabel.append(WhatsAppToggleSpan);

    let WhatsAppToggleIcon = document.createElement("img");
    WhatsAppToggleIcon.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/WhatsApp.svg";
    WhatsAppToggleIcon.className = "BiggerSizeIcon";
    WhatsAppToggleIcon.style.margin = "auto 0";
    WhatsAppToggleWrap.append(WhatsAppToggleIcon);

    let WhatsAppToggleText = document.createElement("p");
    WhatsAppToggleText.className = "SmallSizeText InterMediumTextFont";
    WhatsAppToggleText.innerHTML = window["ThisPhonehasWATxt" + window.CurrentCountryID];
    WhatsAppToggleText.style.margin = "auto 0";
    WhatsAppToggleWrap.append(WhatsAppToggleText);


    /* WhatsApp Number ----------------------------------------------- */

    let WANumberWrap = document.createElement("div");
    WANumberWrap.className = "RowGapBasic4";
    WANumberWrap.style.display = "";
    WANumberWrap.style.flexDirection = "column";
    Section6UserInfoScrollContainer.append(WANumberWrap);

    let WANumberLabel = document.createElement("p");
    WANumberLabel.className = "SmallSizeText InterMediumTextFont";
    WANumberLabel.style.color = "#344054";
    WANumberLabel.innerHTML = window["WhatsAppNumberTxt" + window.CurrentCountryID] + ' <span style="color: #c10000">*</span>';
    WANumberWrap.append(WANumberLabel);

    let WANumberInputWrap = document.createElement("div");
    WANumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
    WANumberInputWrap.style.display = "flex";
    WANumberWrap.append(WANumberInputWrap);

    let WAPrefix = document.createElement("div");
    WAPrefix.className = "SmallTextContainerInsideInputField BasicRadius ColumnGapBasic";
    WANumberInputWrap.append(WAPrefix);

    let WAIcon2 = document.createElement("img");
    WAIcon2.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/WhatsApp.svg";
    WAIcon2.className = "SlightlyBigSizeIcon";
    WAPrefix.append(WAIcon2);

    let WACode = document.createElement("p");
    WACode.className = "MidSizeText2 InterMediumTextFont";
    WACode.style.color = "#667085";
    WACode.innerHTML = "+62";
    WAPrefix.append(WACode);

    let WANumberInput = document.createElement("input");
    WANumberInput.type = "number";
    WANumberInput.className = "InputFieldPadding MidSizeText2 InterMediumTextFont";
    WANumberInput.placeholder = "8123456789";
    WANumberInputWrap.append(WANumberInput);

    let WANumberWarn = document.createElement("div");
    WANumberWarn.className = "WarningTextImgWrapper ColumnGapBasic4";
    WANumberWrap.append(WANumberWarn);

    let WANumberWarnImg = document.createElement("img");
    WANumberWarnImg.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/warning-red.svg";
    WANumberWarn.append(WANumberWarnImg);

    let WANumberWarnText = document.createElement("p");
    WANumberWarnText.className = "SmallSizeText InterMediumTextFont";
    WANumberWarnText.innerHTML = window["WhatsAppNumberEmptyTxt" + window.CurrentCountryID];
    WANumberWarn.append(WANumberWarnText);


    /* Section 6 Button ----------------------------------------------- */

    let Section6ButtonWrapper = document.createElement("div");
    Section6ButtonWrapper.className = "ColumnGapBasic2";
    Section6ButtonWrapper.style.display = "flex";
    Section6ButtonWrapper.style.margin = "0 auto";
    Section6UserInfoContainer.append(Section6ButtonWrapper);

    let Section6BackButton = document.createElement("button");
    Section6BackButton.className = "MidUIButton BasicRadius GreyOutlineButton ExtendedButton Selectable";
    Section6ButtonWrapper.append(Section6BackButton);

    let Section6BackButtonText = document.createElement("p");
    Section6BackButtonText.className = "InterMediumTextFont";
    Section6BackButtonText.innerHTML = window["BackTxt" + window.CurrentCountryID];
    Section6BackButton.append(Section6BackButtonText);

    let Section6NextButton = document.createElement("button");
    Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    Section6ButtonWrapper.append(Section6NextButton);

    let Section6NextButtonText = document.createElement("p");
    Section6NextButtonText.className = "InterMediumTextFont";
    Section6NextButtonText.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    Section6NextButton.append(Section6NextButtonText);


    // SET FUNCTION =======================================================================

    let CheckFunctionToCall = function(whichsection, isallowchange)
    {
        CheckListingMitraInput(whichsection, isallowchange, HeaderMainMessageText, ChooseYourAcccommodationScrollContainer, OthersInputWrap, OthersTextInput, OthersAccWarning, OthersAccWarningText, Section1Button,
        AccommodationNameInputContainer, AccommodationNameInputField, AccommodationNameWarning, AccommodationNameWarningText, Section2BtnNext,
        ProvinceInputWrap, ProvinceDropdown, ProvinceWarning, ProvinceWarnText, CityInputWrap, CityDropdown, CityWarning, CityWarnText, AlamatLengkapInputWrap, AlamatLengkapInput, AlamatLengkapWarningWrapper, AlamatLengkapWarningText, GoogleMapsURLInputWrap, GoogleMapsURLInput, GoogleMapsURLWarning, GoogleMapsURLWarnText, Section3NextButton,
        InstagramInputWrap, InstagramInput, InstagramWarning, InstagramWarningText, TiktokInputWrap, TiktokInput, TiktokWarning, TiktokWarningText, Section4NextButton,
        RoomQuantityInputWrap, RoomQuantityInput, RoomQuantityWarning, RoomQuantityWarnText, PriceFromInputWrap, PriceFromInput, RoomPriceWrapper, RoomPriceText, PriceToInputWrap, PriceToInput, Section5NextButton,
        UsernameInputWrap, UsernameInput, UsernameWarn, UsernameWarnText, GenderDropDownMainContainer, DepartmentInputWrap, DepartmentInput, DepartmentWarn, DepartmentWarnText, EmailInputWrap, EmailInput, EmailWarn, EmailWarnText, PhoneNumberInputWrap, PhoneNumberInput, PhoneNumberWarn, PhoneNumberWarnText, WhatsAppToggleInput, WANumberWrap, WANumberInputWrap, WANumberInput, WANumberWarn, WANumberWarnText, Section6NextButton);
    }

    // Section 1 ------------------------------------------------------------------------

    OthersTextInput.onfocus = function()
    {
        OthersInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        OthersAccWarning.style.display = "";
        Section1Button.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    OthersTextInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(1, true);
    });

    Section1Button.onclick = function()
    {
        window.MovePanelInsideContainerNext(ChooseYourAcccommodatioMainContainer, AccommodationNameMainContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(2, false));
    }

    // Section 2 ------------------------------------------------------------------------
    AccommodationNameInputField.onfocus = function() // Accommodation Name ---------------
    {
        AccommodationNameInputContainer.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        AccommodationNameWarning.style.display = "";
        Section2BtnNext.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    AccommodationNameInputField.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(2, true);
    });

    Section2BtnBack.onclick = function() // Back ---------------
    {
        window.MovePanelInsideContainerBack(AccommodationNameMainContainer, ChooseYourAcccommodatioMainContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(1, false));
    }
    Section2BtnNext.onclick = function() // Next ---------------
    {
        window.MovePanelInsideContainerNext(AccommodationNameMainContainer, Section3AccommodationLocationMainContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(3, false));
    }

    // Section 3 ------------------------------------------------------------------------
    ProvinceInputWrap.onclick = function(event) // Province ---------------
    {
        ProvinceDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2";
        ProvinceWarning.style.display = "";
        window.PrepareProvinceDropDown(event, ProvinceInputWrap, ProvinceInput, "ListingMitraProvince", CityInputWrap, CityInput, ()=> CheckFunctionToCall(3, true));
    }

    CityInputWrap.onclick = function(event) // City Region ---------------
    {
        CityDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2";
        CityWarning.style.display = "";
        window.PrepareCityRegionDropDown(event, CityInputWrap, CityInput, "ListingMitraCityRegion", ProvinceInputWrap, ()=> CheckFunctionToCall(3, true));
    }

    AlamatLengkapInput.onfocus = function() // Alamat Lengkap ---------------
    {
        AlamatLengkapInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        AlamatLengkapWarningWrapper.style.display = "";
        Section3NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    AlamatLengkapInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(3, true);
    });

    GoogleMapsURLInput.onfocus = function() // Google Maps ---------------
    {
        GoogleMapsURLInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        GoogleMapsURLWarning.style.display = "";
        Section3NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    GoogleMapsURLInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(3, true);
    });

    Section3BackButton.onclick = function() // Back ---------------
    {
        window.MovePanelInsideContainerBack(Section3AccommodationLocationMainContainer, AccommodationNameMainContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(2, false));
    }
    Section3NextButton.onclick = function() // Next ---------------
    {
        window.MovePanelInsideContainerNext(Section3AccommodationLocationMainContainer, Section4AccSocialAndImageContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(4, false));
    }


    // Section 4 ------------------------------------------------------------------------
    AccPhotoUploadBox.onclick = function(event) // Upload Photo ---------------
    {
        ImageInputFieldHide.click();
    }
    ImageInputFieldHide.onclick = function()
    {
        ImageInputFieldHide.value = null;
    }
    ImageInputFieldHide.onchange = function()
    {
        OnUploadedMitraImage(ImageInputFieldHide, AccPhotoSwiperWrapper, ()=>CheckFunctionToCall(4, true));
    }

    InstagramInput.onfocus = function() // Instagram ---------------
    {
        InstagramInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        InstagramWarning.style.display = "";
        Section4NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    InstagramInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(4, true);
    });

    TiktokInput.onfocus = function() // Tiktok ---------------
    {
        TiktokInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        TiktokWarning.style.display = "";
        Section4NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    TiktokInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(4, true);
    });


    Section4BackButton.onclick = function() // Back ---------------
    {
        window.MovePanelInsideContainerBack(Section4AccSocialAndImageContainer, Section3AccommodationLocationMainContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(3, false));
    }
    Section4NextButton.onclick = function() // Next ---------------
    {
        window.MovePanelInsideContainerNext(Section4AccSocialAndImageContainer, Section5AccPriceQuantContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(5, false));
    }


    // Section 5 ------------------------------------------------------------------------
    RoomQuantityInput.onfocus = function() // Instagram ---------------
    {
        RoomQuantityInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        RoomQuantityWarning.style.display = "";
        Section5NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    RoomQuantityInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(5, true);
    });

    PriceFromInput.onfocus = function() // Instagram ---------------
    {
        PriceFromInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        PriceToInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        RoomPriceWrapper.style.display = "";
        Section5NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    PriceFromInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(5, true);
    });

    PriceToInput.onfocus = function() // Instagram ---------------
    {
        PriceFromInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        PriceToInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        RoomPriceWrapper.style.display = "";
        Section5NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    PriceToInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(5, true);
    });

    Section5BackButton.onclick = function() // Back ---------------
    {
        window.MovePanelInsideContainerBack(Section5AccPriceQuantContainer, Section4AccSocialAndImageContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(4, false));
    }
    Section5NextButton.onclick = function() // Next ---------------
    {
        window.MovePanelInsideContainerNext(Section5AccPriceQuantContainer, Section6UserInfoContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(6, false));
    }

    // Section 6 ------------------------------------------------------------------------
    UsernameInput.onfocus = function() // Instagram ---------------
    {
        UsernameInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        UsernameWarn.style.display = "";
        Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    UsernameInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(6, true);
    });

    GenderDropDownMainContainer.onclick = function(event) // City Region ---------------
    {
        window.InstantiateGenderDropDown(event, GenderDropDownMainContainer, GenderDropDownInput, "ListingMitraGender", ()=>CheckFunctionToCall(6, true));
    }

    DepartmentInput.onfocus = function() // Department ---------------
    {
        DepartmentInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        DepartmentWarn.style.display = "";
        Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    DepartmentInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(6, true);
    });

    EmailInput.onfocus = function() // Email ---------------
    {
        EmailInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3";
        EmailWarn.style.display = "";
        Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    EmailInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(6, true);
    });

    PhoneNumberInput.onfocus = function() // Phone Number ---------------
    {
        PhoneNumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        PhoneNumberWarn.style.display = "";
        Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    PhoneNumberInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(6, true);
    });

    WhatsAppToggleInput.onchange = function() // WA Toggle ---------------
    {
        CheckFunctionToCall(6, true);
    }

    WANumberInput.onfocus = function() // WhatsApp ---------------
    {
        WANumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder";
        WANumberWarn.style.display = "";
        Section6NextButton.className = "MidUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
    }
    WANumberInput.addEventListener("focusout", (event) =>
    {
        CheckFunctionToCall(6, true);
    });

    Section6BackButton.onclick = function()
    {
        window.MovePanelInsideContainerBack(Section6UserInfoContainer, Section5AccPriceQuantContainer, FlexContainerBaseAnimate, ()=> CheckFunctionToCall(5, false));
    }


    // CALL FUNCTION =======================================================================
    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// ====================================== CHECK LISTING MITRA ========================================

function CheckListingMitraInput(whichsection, isallowchange, HeaderMainMessageText, ChooseYourAcccommodationScrollContainer, OthersInputWrap, OthersTextInput, OthersAccWarning, OthersAccWarningText, Section1Button,
        AccommodationNameInputContainer, AccommodationNameInputField, AccommodationNameWarning, AccommodationNameWarningText, Section2BtnNext,
        ProvinceInputWrap, ProvinceDropdown, ProvinceWarning, ProvinceWarnText, CityInputWrap, CityDropdown, CityWarning, CityWarnText, AlamatLengkapInputWrap, AlamatLengkapInput, AlamatLengkapWarningWrapper, AlamatLengkapWarningText, GoogleMapsURLInputWrap, GoogleMapsURLInput, GoogleMapsURLWarning, GoogleMapsURLWarnText, Section3NextButton,
        InstagramInputWrap, InstagramInput, InstagramWarning, InstagramWarningText, TiktokInputWrap, TiktokInput, TiktokWarning, TiktokWarningText, Section4NextButton,
        RoomQuantityInputWrap, RoomQuantityInput, RoomQuantityWarning, RoomQuantityWarnText, PriceFromInputWrap, PriceFromInput, RoomPriceWrapper, RoomPriceText, PriceToInputWrap, PriceToInput, Section5NextButton,
        UsernameInputWrap, UsernameInput, UsernameWarn, UsernameWarnText, GenderDropDownMainContainer, DepartmentInputWrap, DepartmentInput, DepartmentWarn, DepartmentWarnText, EmailInputWrap, EmailInput, EmailWarn, EmailWarnText, PhoneNumberInputWrap, PhoneNumberInput, PhoneNumberWarn, PhoneNumberWarnText, WhatsAppToggleInput, WANumberWrap, WANumberInputWrap, WANumberInput, WANumberWarn, WANumberWarnText, Section6NextButton)
{

    let IsError = false;

    // Change Header Accordingly ------------------------------

    HeaderMainMessageText.innerHTML = window["BermitraTopMessageTxt" + whichsection + window.CurrentCountryID];

    let CheckBoxes1stSection = ChooseYourAcccommodationScrollContainer.querySelectorAll('[name="TypeOfAccomodationBermitra"]');
    let AtLeast1Checked = false;
    let TypeAccommodationChecked = "";
    CheckBoxes1stSection.forEach(ThisCheckBox =>
    {
        if(ThisCheckBox.checked == true)
        {
            TypeAccommodationChecked = ThisCheckBox.value;

            if(TypeAccommodationChecked == "Others")
            {
                if(OthersTextInput.value.replace(/ /g, "") == "")
                {
                    AtLeast1Checked = false;
                }
                else
                {
                    TypeAccommodationChecked = OthersTextInput.value;
                }
            }
            else
            {
                AtLeast1Checked = true;
            }
        }
    });
    
    /* 1st Section ----------------------------------------------- */

    if(whichsection == 1)
    {
        if(AtLeast1Checked == false)
        {
            if(TypeAccommodationChecked == "Others")
            {
                OthersInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                OthersAccWarning.style.display = "flex";
                OthersAccWarningText.innerHTML = window["OtherAccommodationCannotEmptyTxt" + window.CurrentCountryID];
            }
            IsError = true;
        }

        if(IsError == true)
        {
            Section1Button.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
        }
        else
        {
            Section1Button.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
        }
    }
    else if(whichsection == 2)
    {
        if(AccommodationNameInputField.value == "" || AccommodationNameInputField.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                AccommodationNameInputContainer.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                AccommodationNameWarning.style.display = "flex";
                AccommodationNameWarningText.innerHTML = window["AccommodationNameCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(IsError == true)
        {
            Section2BtnNext.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
        }
        else
        {
            Section2BtnNext.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
        }
    }
    else if(whichsection == 3)
    {
        let GetProvinceInput = ProvinceInputWrap.getAttribute("which-province");
        let GetCityRegionInput = CityInputWrap.getAttribute("which-city-region");

        if(GetProvinceInput == "") // Province ---------------------------
        {
            IsError = true;
            if(isallowchange == true)
            {
                ProvinceDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2 InputFieldWarningOutline";
                ProvinceWarning.style.display = "flex";
                ProvinceWarnText.innerHTML = window["ProvinceCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(GetCityRegionInput == "") // City Region ---------------------------
        {
            IsError = true;
            if(isallowchange == true)
            {
                CityDropdown.className = "SmallPanelDropDownInputWrapper Selectable3 BasicRadius BasicGreyBorder InputFieldPadding ColumnGapBasic2 InputFieldWarningOutline";
                CityWarning.style.display = "flex";
                CityWarnText.innerHTML = window["CityRegionCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(AlamatLengkapInput.value == "" || AlamatLengkapInput.value.replace(/ /g, "") =="") // Alamat Lengkap ---------------------------
        {
            IsError = true;
            if(isallowchange == true)
            {
                AlamatLengkapInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                AlamatLengkapWarningWrapper.style.display = "flex";
                AlamatLengkapWarningText.innerHTML = window["FullAddressCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(GoogleMapsURLInput.value == "" || GoogleMapsURLInput.value.replace(/ /g, "") =="") // Google Maps ---------------------------
        {
            IsError = true;
            if(isallowchange == true)
            {
                GoogleMapsURLInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                GoogleMapsURLWarning.style.display = "flex";
                GoogleMapsURLWarnText.innerHTML = window["GoogleMapsUrlCannotEmptyTxt" + window.CurrentCountryID];
            }
        }
        else if(window.CheckIsValidURL(GoogleMapsURLInput.value, "Google Maps") == false)
        {
            IsError = true;
            if(isallowchange == true)
            {
                GoogleMapsURLInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                GoogleMapsURLWarning.style.display = "flex";
                GoogleMapsURLWarnText.innerHTML = window["URLFormatInvalidTxt" + window.CurrentCountryID];
            }
        }

        if(IsError == true)
        {
            Section3NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
        }
        else
        {
            Section3NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
        }

    }
    else if(whichsection == 4)
    {
        if(window.UploadedListingMitraImage.length <= 0)
        {
            IsError = true;
        }

        if(InstagramInput.value == "" || InstagramInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                InstagramInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                InstagramWarning.style.display = "flex";
                InstagramWarningText.innerHTML = window["InstagramEmptyTxt" + window.CurrentCountryID];
            }
        }
        else if(window.CheckIsValidURL(InstagramInput.value, "Instagram") == false)
        {
            IsError = true;
            if(isallowchange == true)
            {
                InstagramInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                InstagramWarning.style.display = "flex";
                InstagramWarningText.innerHTML = window["URLFormatInvalidTxt" + window.CurrentCountryID];
            }
        }

        if(TiktokInput.value == "" || TiktokInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                TiktokInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                TiktokWarning.style.display = "flex";
                TiktokWarningText.innerHTML = window["TikTokEmptyTxt" + window.CurrentCountryID];
            }
        }
        else if(window.CheckIsValidURL(TiktokInput.value, "TikTok") == false)
        {
            IsError = true;
            if(isallowchange == true)
            {
                TiktokInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                TiktokWarning.style.display = "flex";
                TiktokWarningText.innerHTML = window["URLFormatInvalidTxt" + window.CurrentCountryID];
            }
        }

        if(IsError == true)
        {
            Section4NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
        }
        else
        {
            Section4NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
        }
    }
    else if(whichsection == 5)
    {
        if(RoomQuantityInput.value == "" || RoomQuantityInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                RoomQuantityInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                RoomQuantityWarning.style.display = "flex";
                RoomQuantityWarnText.innerHTML = window["TotalRoomsCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(PriceFromInput.value == "" || PriceFromInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                PriceFromInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                RoomPriceWrapper.style.display = "flex";
                RoomPriceText.innerHTML = window["MinRoomRatesCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(PriceToInput.value == "" || PriceToInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                PriceToInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                RoomPriceWrapper.style.display = "flex";
                RoomPriceText.innerHTML = window["MaxRoomRatesCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(parseInt(PriceToInput.value) < parseInt(PriceFromInput.value))
        {
            IsError = true;
            if(isallowchange == true)
            {
                PriceFromInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                PriceToInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                RoomPriceWrapper.style.display = "flex";
                RoomPriceText.innerHTML = window["MaxRoomRatesPricesCannotLowerTxt" + window.CurrentCountryID];
            }
        }

        if(IsError == true)
        {
            Section5NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
        }
        else
        {
            Section5NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
        }
    }
    else if(whichsection == 6)
    {
        if(UsernameInput.value == "" || UsernameInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                UsernameInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                UsernameWarn.style.display = "flex";
                UsernameWarnText.innerHTML = window["FullNameCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(DepartmentInput.value == "" || DepartmentInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                DepartmentInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                DepartmentWarn.style.display = "flex";
                DepartmentWarnText.innerHTML = window["DepartmentCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(EmailInput.value == "" || EmailInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                EmailInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                EmailWarn.style.display = "flex";
                EmailWarnText.innerHTML = window["EmailCannotEmptyTxt" + window.CurrentCountryID];
            }
        }
        else if(window.CheckIsValidURL(EmailInput.value, "Email") == false)
        {
            IsError = true;
            if(isallowchange == true)
            {
                EmailInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder Selectable3 InputFieldWarningOutline";
                EmailWarn.style.display = "flex";
                EmailWarnText.innerHTML = window["URLFormatInvalidTxt" + window.CurrentCountryID];
            }
        }

        if(PhoneNumberInput.value == "" || PhoneNumberInput.value.replace(/ /g, "") =="") // Accomo ----------
        {
            IsError = true;
            if(isallowchange == true)
            {
                PhoneNumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                PhoneNumberWarn.style.display = "flex";
                PhoneNumberWarnText.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
            }
        }


        if(WhatsAppToggleInput.checked == true)
        {
            WANumberWrap.style.display = "none";
        }
        else
        {
            WANumberWrap.style.display = "";

            if(WANumberInput.value == "" || WANumberInput.value.replace(/ /g, "") =="") // Accomo ----------
            {
                IsError = true;
                if(isallowchange == true)
                {
                    WANumberInputWrap.className = "BasicInputFieldContainer BasicRadius BasicGreyBorder InputFieldWarningOutline";
                    WANumberWarn.style.display = "flex";
                    WANumberWarnText.innerHTML = window["WhatsAppNumberEmptyTxt" + window.CurrentCountryID];
                }
            }
        }

        if(IsError == true)
        {
            Section6NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton ButtonInvalid";
            Section6NextButton.onclick = function(){};
        }
        else
        {
            Section6NextButton.className = "BigUIButton BasicRadius OrangeButton ExtendedButton Selectable";
            Section6NextButton.onclick = function()
            {
                console.log(CityInputWrap);

                let GetProvinceInput = ProvinceInputWrap.getAttribute("which-name");
                let GetCityRegionInput = CityInputWrap.getAttribute("which-name");
                let WhichGender = GenderDropDownMainContainer.getAttribute("which-gender");

                let formData = new FormData();
                formData.append('hotel_category', TypeAccommodationChecked);
                formData.append('hotel_name', AccommodationNameInputField.value);
                formData.append('province', GetProvinceInput);
                formData.append('city_region', GetCityRegionInput);
                formData.append('full_address', AlamatLengkapInput.value);
                formData.append('gmaps_link', GoogleMapsURLInput.value);
                formData.append('instagram', InstagramInput.value);
                formData.append('tiktok', TiktokInput.value);
                formData.append('total_room', RoomQuantityInput.value);
                formData.append('min_rate', PriceFromInput.value);
                formData.append('max_rate', PriceToInput.value);
                formData.append('full_name', UsernameInput.value);
                formData.append('gender', WhichGender);
                formData.append('department', DepartmentInput.value);
                formData.append('email', EmailInput.value);
                formData.append('phone_number', PhoneNumberInput.value);

                if(WhatsAppToggleInput.checked == true)
                {
                    formData.append('whatsapp', PhoneNumberInput.value);
                }
                else
                {
                    formData.append('whatsapp', WANumberInput.value);
                }

                PushListingMitraData(formData)
            }
        }
    }
}

function PushListingMitraData(formData)
{
    console.log(window.ConvertFormDataToJSON(formData));
    
    let PushNewMitraBlocker = window.InstantiateLoadingBlocker("PushNewMitraBlocker");

    fetch("/Assets/function/push_request_mitra.php",
    {
        method: "POST",
        body: formData,
    })
    .then(res => res.json())
    .then(function(data)
    {
        let PushRequestMitraData = data;
        console.log("Push Request Mitra Data...");
        console.log(PushRequestMitraData);
    
        if(PushRequestMitraData.status_insert_join_mitra == "Done")
        {
            let CheckHowManyPushed = [];
            let CheckHowManyTry = [];

            for(let i = 0; i < window.UploadedListingMitraImage.length; i++)
            {
                let PushImageFormData = new FormData();
                PushImageFormData.append('image', window.UploadedListingMitraImage[i]);
                PushImageFormData.append('id_join_mitra', PushRequestMitraData.id_join_mitra);

                console.log(window.ConvertFormDataToJSON(PushImageFormData));

                fetch("/Assets/function/push_request_mitra_photo.php",
                {
                    method: "POST",
                    body: PushImageFormData,
                })
                .then(res => res.json())
                .then(function(data)
                {
                    let PushMitraImageData = data;
                    console.log("Push Mitra Image Data...");
                    console.log(PushMitraImageData);

                    CheckHowManyTry.push(PushMitraImageData);
    
                    if(PushMitraImageData.status_save_photo_hotel_mitra == "Berhasil update foto")
                    {
                        CheckHowManyPushed.push(PushMitraImageData);
                    }

                    if(CheckHowManyTry.length == window.UploadedListingMitraImage.length)
                    {
                        if(CheckHowManyPushed.length == window.UploadedListingMitraImage.length)
                        {
                            window.DisplayWarningUpload("WarningPanelSuccess", "Send Request Bermitra Success");
                            InstantiateSuccessBermitraPanel();
                        }
                        else if(CheckHowManyPushed.length != window.UploadedListingMitraImage.length && CheckHowManyPushed.length > 0)
                        {
                            window.DisplayWarningUpload("WarningPanelFailed WarningFailedAlert", "Successfully Request Bermitra. But Some Images Failed To Upload");
                            InstantiateSuccessBermitraPanel();
                        }
                        else
                        {
                            window.DisplayWarningUpload("WarningPanelFailed WarningFailedAlert", "Push Image Mitra Failed");
                            PushNewMitraBlocker.remove();
                        }
                    }
                })
                .catch(function(error)
                {
                    console.log(error);
                    window.DisplayWarningUpload("WarningPanelFailed WarningFailedAlert", "Push Request Mitra Failed");
                    PushNewMitraBlocker.remove();
                });
    
            }
        }
        else
        {
            window.DisplayWarningUpload("WarningPanelFailed WarningFailedAlert", "Push Request Mitra Failed");
            PushNewMitraBlocker.remove();
        }
    })
    .catch(function(error)
    {
        console.log(error);
        window.DisplayWarningUpload("WarningPanelFailed WarningFailedAlert", "Push Request Mitra Failed");
        PushNewMitraBlocker.remove();
    });
}

function InstantiateSuccessBermitraPanel()
{
    window.ClosePanelAnimate(document.getElementById("JoinMitraFlexDisplay"), document.getElementById("PopUpPanelBlockerBermitra"), null);

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel HideScrollBar BasicRadius";
    FlexFullDisplayPanel.style.maxHeight = "none";
    BasicBlackBlocker.append(FlexFullDisplayPanel);
    
    let FinalSuccessContainer = document.createElement("div");
    FinalSuccessContainer.className = "FlexContainerBaseAnimate RowGapBasic";
    FlexFullDisplayPanel.append(FinalSuccessContainer);


    // Top Close Bar ----------------------------------------------------------------------

    let TopBar = document.createElement("div");
    TopBar.style.width = "100%";
    TopBar.style.height = "fit-content";
    TopBar.style.margin = "0 auto";
    TopBar.style.flexDirection = "column";
    TopBar.style.display = "flex";
    FinalSuccessContainer.append(TopBar);

    let CloseButton = document.createElement("img");
    CloseButton.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel";
    CloseButton.style.marginLeft = "auto";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    TopBar.append(CloseButton);


    // Basic Content ----------------------------------------------------------------------

    let ContentWrapper = document.createElement("div");
    ContentWrapper.className = "SmallSizePopUpPanelWrapper RowGapBasic HideScrollBar RowGapBasic4";
    FinalSuccessContainer.append(ContentWrapper);

    let SuccessImage = document.createElement("img");
    SuccessImage.src = process.env.PUBLIC_URL + "/Assets/images/Icon/Accommodation_Submitted.png";
    SuccessImage.className = "HugeSizeIcon";
    SuccessImage.style.margin = "0 auto";
    ContentWrapper.append(SuccessImage);

    let TitleText = document.createElement("p");
    TitleText.className = "LessBigSizeText SpecialBigSizeLineHeight PoppinsBoldTextFont";
    TitleText.style.margin = "0 auto";
    TitleText.style.textAlign = "center";
    TitleText.style.color = "rgb(35, 41, 51)";
    TitleText.innerText = window["AccommodationSubmittedTxt" + window.CurrentCountryID];
    ContentWrapper.append(TitleText);

    let DescText = document.createElement("p");
    DescText.className = "MidSizeText2 PoppinsRegularTextFont";
    DescText.style.margin = "0 auto";
    DescText.style.textAlign = "center";
    DescText.innerText = window["HelloThankyouForSubmittingAccTxt" + window.CurrentCountryID];
    ContentWrapper.append(DescText);

    // Call Instantiate Panel ----------------------------------------------------------------------

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


// ====================================== INSTANTIATE UPLOAD PHOTO ========================================

function OnUploadedMitraImage(whichinputfield, wheretoinstantiate, functiontocall)
{
    let ThisUploadedFiles = whichinputfield.files;
    let AcceptedFiles = [];

    for(let i = 0; i < ThisUploadedFiles.length; i++)
    {
        if(ThisUploadedFiles[i].size / (1024 * 1024) > 10)
        {
            window.alert("The Uploaded Photo has size over 10 MB!")
        }
        else
        {
            window.UploadedListingMitraImage.push(ThisUploadedFiles[i]);
            AcceptedFiles.push(ThisUploadedFiles[i]);
        }
    }

    InstantiateUploadPhotoListing(AcceptedFiles, wheretoinstantiate, functiontocall)
}

function InstantiateUploadPhotoListing(uploadedphoto, wheretoinstantiate, functiontocall)
{
    uploadedphoto.forEach(thisphoto =>
    {
        let UploadedAccPhotoContainer = document.createElement("div");
        UploadedAccPhotoContainer.className = "ListOfUploadedPhotoSwiper BasicRadius BasicLightGreyBorder BasicPaddingWrapper swiper-slide";
        wheretoinstantiate.append(UploadedAccPhotoContainer);

        let UploadedAccPhotoMainWrapper = document.createElement("div");
        UploadedAccPhotoMainWrapper.className = "ColumnGapBasic";
        UploadedAccPhotoMainWrapper.style.flex = "1";
        UploadedAccPhotoMainWrapper.style.display = "flex";
        UploadedAccPhotoContainer.append(UploadedAccPhotoMainWrapper);

        let Item1Img = document.createElement("img");
        Item1Img.className = "BiggestSizeIcon FullScreenImage BasicRadius";
        Item1Img.src = process.env.PUBLIC_URL + URL.createObjectURL(thisphoto);
        Item1Img.style.backgroundColor = "#e6e6e6";
        Item1Img.style.objectFit = "cover";
        UploadedAccPhotoMainWrapper.append(Item1Img);

        let Item1TextWrap = document.createElement("div");
        Item1TextWrap.className = "ListOfUploadedBermitraTextWrapper";
        UploadedAccPhotoMainWrapper.append(Item1TextWrap);

        let Item1Name = document.createElement("p");
        Item1Name.className = "MidSizeText2 RobotoBoldTextFont";
        Item1Name.innerHTML = thisphoto.name;
        Item1TextWrap.append(Item1Name);

        let Item1Size = document.createElement("p");
        Item1Size.className = "SmallSizeText RobotoTextFont";
        Item1Size.innerHTML = window.DetermineSizeFile(thisphoto.size);
        Item1TextWrap.append(Item1Size);

        let Item1Delete = document.createElement("img");
        Item1Delete.className = "BiggerSizeIcon Selectable2";
        Item1Delete.src = process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/x-delete-swiper.svg";
        Item1Delete.onclick = function()
        {
            for(let j = 0; j < window.UploadedListingMitraImage.length; j++)
            {
                if(window.UploadedListingMitraImage[j] == thisphoto)
                {
                    window.UploadedListingMitraImage.splice(j, 1);
                    UploadedAccPhotoContainer.remove();
                }
            }

            functiontocall();
        }
        UploadedAccPhotoMainWrapper.append(Item1Delete);

        let ProgressUploadWrapper = document.createElement("div");
        ProgressUploadWrapper.className = "ProgressUploadWrapper";
        UploadedAccPhotoContainer.append(ProgressUploadWrapper);

        let ProgressUploadContainer = document.createElement("div");
        ProgressUploadContainer.className = "ProgressUploadContainer";
        ProgressUploadWrapper.append(ProgressUploadContainer);

        let ProgressUploadBlue = document.createElement("div");
        ProgressUploadBlue.className = "ProgressUploadBlue";
        ProgressUploadContainer.append(ProgressUploadBlue);

        let ProgressUploadPercentageText = document.createElement("p");
        ProgressUploadPercentageText.className = "MidSizeText3 RobotoBoldTextFont";
        ProgressUploadPercentageText.innerHTML = "100%";
        ProgressUploadWrapper.append(ProgressUploadPercentageText);
    });


    functiontocall();
}



// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SERVICE PAGE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.PrepareServicePageElements = function()
{
    document.getElementById("PropertyAuditText").innerHTML = window["PropertyAuditFullTxt" + window.CurrentCountryID];
    document.getElementById("PropertyAuditMobileText").innerHTML = window["PropertyAuditTxt" + window.CurrentCountryID];

    document.getElementById("Section1Header1Text").innerHTML = window["KelolaOTAHeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section1Header2Text").innerHTML = window["BookingTetapJalanHeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section1MessageText").innerHTML = window["ExperienceSection1MessageTxt" + window.CurrentCountryID];
    document.getElementById("Section1Button1Text").innerHTML = window["Free15MinutesBtnTxt" + window.CurrentCountryID];
    document.getElementById("Section1Button2Text").innerHTML = window["DownloadOurProposalBtnTxt" + window.CurrentCountryID];

    document.getElementById("SiapaSection2Text").innerHTML = window["SiapaHeaderTxt" + window.CurrentCountryID];
    document.getElementById("PinginGoSection2Text").innerHTML = window["PinginGoTxt" + window.CurrentCountryID];
    document.getElementById("Section2Message1").innerHTML = window["ExperienceSectioneMessage1Txt" + window.CurrentCountryID];
    document.getElementById("Section2Message2").innerHTML = window["ExperienceSectioneMessage2Txt" + window.CurrentCountryID];

    document.getElementById("Section3HeaderText").innerHTML = window["ExperienceSectionHeader3Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText1").innerHTML = window["ExperienceMasalah1Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText2").innerHTML = window["ExperienceMasalah2Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText3").innerHTML = window["ExperienceMasalah3Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText4").innerHTML = window["ExperienceMasalah4Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText5").innerHTML = window["ExperienceMasalah5Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText6").innerHTML = window["ExperienceMasalah6Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText7").innerHTML = window["ExperienceMasalah7Txt" + window.CurrentCountryID];
    document.getElementById("Section3MasalahText8").innerHTML = window["ExperienceMasalah8Txt" + window.CurrentCountryID];

    document.getElementById("Section4HeaderText").innerHTML = window["ExperienceSectionHeader4Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi1HeaderText").innerHTML = window["ExperienceSolusiHeader1Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi1MessageText").innerHTML = window["ExperienceSolusiMessage1Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi2HeaderText").innerHTML = window["ExperienceSolusiHeader2Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi2MessageText").innerHTML = window["ExperienceSolusiMessage2Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi3HeaderText").innerHTML = window["ExperienceSolusiHeader3Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi3MessageText").innerHTML = window["ExperienceSolusiMessage3Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi4HeaderText").innerHTML = window["ExperienceSolusiHeader4Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi4MessageText").innerHTML = window["ExperienceSolusiMessage4Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi5HeaderText").innerHTML = window["ExperienceSolusiHeader5Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi5MessageText").innerHTML = window["ExperienceSolusiMessage5Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi6HeaderText").innerHTML = window["ExperienceSolusiHeader6Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi6MessageText").innerHTML = window["ExperienceSolusiMessage6Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi7HeaderText").innerHTML = window["ExperienceSolusiHeader7Txt" + window.CurrentCountryID];
    document.getElementById("Section4Solusi7MessageText").innerHTML = window["ExperienceSolusiMessage7Txt" + window.CurrentCountryID];

    document.getElementById("Section5HeaderText").innerHTML = window["ExperienceSection5HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader1Text").innerHTML = window["ExperienceSection5ReasonHeader1Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage1Text").innerHTML = window["ExperienceSection5ReasonMessage1Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader2Text").innerHTML = window["ExperienceSection5ReasonHeader2Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage2Text").innerHTML = window["ExperienceSection5ReasonMessage2Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader3Text").innerHTML = window["ExperienceSection5ReasonHeader3Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage3Text").innerHTML = window["ExperienceSection5ReasonMessage3Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader4Text").innerHTML = window["ExperienceSection5ReasonHeader4Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage4Text").innerHTML = window["ExperienceSection5ReasonMessage4Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader5Text").innerHTML = window["ExperienceSection5ReasonHeader5Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage5Text").innerHTML = window["ExperienceSection5ReasonMessage5Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonHeader6Text").innerHTML = window["ExperienceSection5ReasonHeader6Txt" + window.CurrentCountryID];
    document.getElementById("Section5ReasonMessage6Text").innerHTML = window["ExperienceSection5ReasonMessage6Txt" + window.CurrentCountryID];

    document.getElementById("Section6HeaderText").innerHTML = window["ExperienceSection6HeaderTxt" + window.CurrentCountryID];
    document.getElementById("AlurHeaderText1").innerHTML = window["ExperienceDaftarHeaderTxt1" + window.CurrentCountryID];
    document.getElementById("AlurMessageText1").innerHTML = window["ExperienceDaftarMessageTxt1" + window.CurrentCountryID];
    document.getElementById("AlurHeaderText2").innerHTML = window["ExperienceDaftarHeaderTxt2" + window.CurrentCountryID];
    document.getElementById("AlurMessageText2").innerHTML = window["ExperienceDaftarMessageTxt2" + window.CurrentCountryID];
    document.getElementById("AlurHeaderText3").innerHTML = window["ExperienceDaftarHeaderTxt3" + window.CurrentCountryID];
    document.getElementById("AlurMessageText3").innerHTML = window["ExperienceDaftarMessageTxt3" + window.CurrentCountryID];
    document.getElementById("AlurHeaderText4").innerHTML = window["ExperienceDaftarHeaderTxt4" + window.CurrentCountryID];
    document.getElementById("AlurMessageText4").innerHTML = window["ExperienceDaftarMessageTxt4" + window.CurrentCountryID];

    document.getElementById("Section7HeaderText").innerHTML = window["ExperienceSection7HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section7MessageText1").innerHTML = window["ExperienceSection7Message1Txt" + window.CurrentCountryID];
    document.getElementById("Section7MessageText2").innerHTML = window["ExperienceSection7Message2Txt" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanHeaderText1").innerHTML = window["HasilDiharapkanHeaderTxt1" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanMessageText1").innerHTML = window["HasilDiharapkanMessageTxt1" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanHeaderText2").innerHTML = window["HasilDiharapkanHeaderTxt2" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanMessageText2").innerHTML = window["HasilDiharapkanMessageTxt2" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanHeaderText3").innerHTML = window["HasilDiharapkanHeaderTxt3" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanMessageText3").innerHTML = window["HasilDiharapkanMessageTxt3" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanHeaderText4").innerHTML = window["HasilDiharapkanHeaderTxt4" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanMessageText4").innerHTML = window["HasilDiharapkanMessageTxt4" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanHeaderText5").innerHTML = window["HasilDiharapkanHeaderTxt5" + window.CurrentCountryID];
    document.getElementById("HasilDiharapkanMessageText5").innerHTML = window["HasilDiharapkanMessageTxt5" + window.CurrentCountryID];

    document.getElementById("Section8HeaderText").innerHTML = window["ExperienceSection8HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section8MessageText").innerHTML = window["ExperienceSection8MessageTxt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText1").innerHTML = window["PaketLayanan1Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText2").innerHTML = window["PaketLayanan2Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText3").innerHTML = window["PaketLayanan3Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText4").innerHTML = window["PaketLayanan4Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText5").innerHTML = window["PaketLayanan5Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText6").innerHTML = window["PaketLayanan6Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText7").innerHTML = window["PaketLayanan7Txt" + window.CurrentCountryID];
    document.getElementById("PaketLayananText8").innerHTML = window["PaketLayanan8Txt" + window.CurrentCountryID];
    document.getElementById("GratisBiayaSetupText").innerHTML = window["GratisBiayaSetupHeaderTxt" + window.CurrentCountryID];
    document.getElementById("BiayaLayananMessageText").innerHTML = window["GratisBiayaSetupMessageTxt" + window.CurrentCountryID];

    document.getElementById("Section8BAddOnsHeaderText").innerHTML = window["AddOnsHeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section8BHeaderText").innerHTML = window["ExperienceSection8BHeaderTxt" + window.CurrentCountryID];
    document.getElementById("AddOnsText1").innerHTML = window["ExperienceAddOns1Txt" + window.CurrentCountryID];
    document.getElementById("AddOnsText2").innerHTML = window["ExperienceAddOns2Txt" + window.CurrentCountryID];
    document.getElementById("AddOnsText3").innerHTML = window["ExperienceAddOns3Txt" + window.CurrentCountryID];
    document.getElementById("AddOnsText4").innerHTML = window["ExperienceAddOns4Txt" + window.CurrentCountryID];
    document.getElementById("AddOnsText5").innerHTML = window["ExperienceAddOns5Txt" + window.CurrentCountryID];

    document.getElementById("Section9HeaderText").innerHTML = window["ExperienceSection9HeaderTxt" + window.CurrentCountryID];
    document.getElementById("Section9ButtonTextMobile").innerHTML = window["JadwalkanAuditBtnMobileTxt" + window.CurrentCountryID];
    document.getElementById("Section9ButtonText").innerHTML = window["JadwalkanAuditBtnTxt" + window.CurrentCountryID];

    
    document.getElementById("AturAkomodasiCheck1").checked = true;
    
    let ourProgramSwipper = new window.Swiper(".SwiperExtraPagecontainer", {
        modules: [window.Navigation, window.Pagination],

        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: false,
        observer: true,
        observeParents: true,

        navigation: {
            prevEl: ".PrevButton",
            nextEl: ".NextButton",
        },

        pagination: {
            el: ".OrangeSwiperPagination",
            clickable: true,
        },
    });

    window.scrollTrigger('.PlayableOnScroll',
    {
        rootMargin: '-200px',
    })

}




// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! OTHER FUNCTION !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

window.OnRadioButtonClicked = function(whichradiobutton, whichimagepreview, whichdirection)
{
    // Determine Which Number is Selected -----------------------------------------------------------------

    let ThisRadioButtons = document.querySelectorAll('input[name="' + whichradiobutton +'"]');
    let WhichButtonSelected = 0;

    for(let i = 0; i < ThisRadioButtons.length; i++)
    {
        if(ThisRadioButtons[i].checked == true)
        {
            WhichButtonSelected = i;
        }
    }

    // Determine Which Image is Selected -----------------------------------------------------------------
    
    let ThisImagePreview = document.querySelectorAll('div[name="' + whichimagepreview +'"]');

    let NewTransitionImage = null;
    let PreviousImage = null;

    for(let i = 0; i < ThisImagePreview.length; i++)
    {
        if(WhichButtonSelected == i)
        {
            NewTransitionImage = ThisImagePreview[i];
        }
        else if(ThisImagePreview[i].classList.contains("ThisSelected"))
        {
            PreviousImage = ThisImagePreview[i];
        }
    }

    if(NewTransitionImage != PreviousImage)
    {
        PreviousImage.style.opacity = 0;
        PreviousImage.style.position = "absolute";
        PreviousImage.style[whichdirection] = "-20%";
        PreviousImage.classList.remove("ThisSelected");
        PreviousImage.animate([{opacity: 1, [whichdirection]: "0%"},{opacity: 0, [whichdirection]: "-20%"}], {duration: AnimatesDurationAtur/2});

        setTimeout(function()
        {
            NewTransitionImage.style.opacity = 1;
            NewTransitionImage.style.position = "relative";
            NewTransitionImage.style[whichdirection] = "0%";
            NewTransitionImage.classList.add("ThisSelected");
            NewTransitionImage.animate([{opacity: 0, [whichdirection]: "-20%"},{opacity: 1, [whichdirection]: "0%"}], {duration: AnimatesDurationAtur});
                    
        }, AnimatesDurationAtur/2);
    }
}





// ================================== SCROLL TRIGGER EXTRA PAGE ========================================

window.scrollTrigger = function(selector, options = {})
{
    let els = document.querySelectorAll(selector);
    els = Array.from(els)
    els.forEach(el =>
    {
        addObserver(el, options)
    })
}

function addObserver(el, options)
{
    let observer = new IntersectionObserver((entries, observer) =>
    {
        entries.forEach(entry =>
        {
            if(entry.isIntersecting)
            {
                if(options.cb)
                {
                    options.cb(el)
                }
                else
                {
                    entry.target.classList.add('PlayAnimation')
                }
                observer.unobserve(entry.target)
            }
        })
    }, options)
    observer.observe(el)
}









